<template>
  <div id="app" style="width: 90%; margin: 0 auto">
    <!--    <global-order-query -->
    <!--      :teams="vips"-->
    <!--      :userId="userInfo.userId"-->
    <!--    ref="globalOrderQuery"/>-->
    <div v-if="popoverManager.enabled">
      <el-popover
          popper-class="waybill-popover2"
          trigger="manual"
          v-model="popoverManager.displaying"
          :visible-arrow="false"
          :style="`width: ${waybillPopoverWidth}; max-width: ${waybillPopoverWidth};`"
      >
        <div style="width: 100%; background: yellow; text-align: center; overflow: hidden; box-sizing: border-box;">
          <span :style="`font-size: clamp(40px, 8vw, ${waybillFontSize}px); color: black; white-space: nowrap; display: inline-block; max-width: 100%; overflow: hidden; text-overflow: ellipsis;`">{{
              popoverManager.waybillId
            }}</span>
        </div>
      </el-popover>
    </div>
    <audio id="audio" src="./src/audio/warning.wav"></audio>
    <!-- 状态显示区 -->
    <div>
      <div>
        <el-popover
            refs="outerPopover"
            trigger="manual"
            popper-class="outer-waybill-popover"
            v-model="outerPopVisible"
            :visible-arrow="false"
            :style="`width: ${waybillPopoverWidth}; max-width: ${waybillPopoverWidth};`"
        >
          <div style="text-align: center; background: yellow; overflow: hidden; box-sizing: border-box; width: 100%;">
          <span :style="`font-size: clamp(40px, 8vw, ${waybillFontSize}px); color: black; white-space: nowrap; display: inline-block; max-width: 100%; overflow: hidden; text-overflow: ellipsis;`">{{
              outerPopoverMsg
            }}</span>
          </div>
        </el-popover>
      </div>
      <div style="position: absolute; top: 10px; left: 20px;"
           v-if="view === 1 && productInfo.productPic && !newSys">
        <el-image style="height: 175px; width: 150px" :src="productInfo.productPic"
                  :preview-src-list="[productInfo.productPic]"></el-image>
        <div v-if="view === 1 && productInfo.productName" style="position: absolute">
          <div style="display: flex; flex-direction: column;">
            <div style="white-space: nowrap; text-align: left;">商品名: {{ productInfo.productName }}</div>
            <div style="white-space: nowrap; text-align: left;">商家编码:
              <span class="sku-code">
              {{ productInfo.code }}
            </span>
            </div>
            <div style="white-space: nowrap; text-align: left;">规格: {{ productInfo.specs }}
            </div>
          </div>
        </div>
      </div>
      <el-tag :type="printConnect">菜鸟打印机通信</el-tag>
      <el-tag :type="davinciPrintConnect">抖店打印机通信</el-tag>
      <el-tag :type="ksPrinterConnect">快手打印机通信</el-tag>
      <el-tag :type="channelPrinterConnect">视频号打印机通信</el-tag>
      <el-tag :type="pddPrinterConnect">拼多多打印机通信</el-tag>
      <el-tag :type="xhsPrinterConnect">小红书打印机通信</el-tag>
      <el-tag :type="loginConnect">{{ "账号:" + userInfo.name }}</el-tag>
      <span style="float: right">
        <div style="display: flex; align-items: center; justify-content: space-evenly;">
          <span style="margin-right: 15px;" @click="boxSendView.switchBoxSend" :title="boxSendView.box ? '盒子发货：已开启' : '盒子发货：已关闭'">
            <i :class="['el-icon-box', boxSendView.getBoxClass()]"></i>
          </span>
          <div style="margin-right: 30px; display: flex; align-items: center;">
            <span style="margin-right: 8px; font-size: 14px; color: #606266;">客户打包物料</span>
            <el-switch
              v-model="customerBagView.bag"
              @change="customerBagView.handleSwitchChange"
              active-color="#E6A23C"
              inactive-color="#C0C4CC">
            </el-switch>
          </div>
          <div style="margin-right: 12px;">
            <span style="margin-right: 5px;">

<!--              <el-link :underline="false" v-if="!newSys">-->
              <!--                <el-tag type="info" effect="plain" @click="changeSys(true)">旧系统</el-tag>-->
              <!--              </el-link>-->
              <!--              <el-link :underline="false" v-if="newSys">-->
              <!--                <el-tag type="success" effect="plain" @click="changeSys(false)">新系统</el-tag>-->
              <!--              </el-link>-->
            </span>
          </div>
          <div style="margin-right: 15px;">
            物流：
            <el-select v-model="logisticsId" placeholder="请选择物流" @change="handleLogisticsChange">
              <el-option v-for="com in LOGISTICS_COMPANIES" :value="com.value" :label="com.label" :key="com.value"
                         :disabled="!superior" v-if="!com.hidden"></el-option>
            </el-select>
          </div>
          <div>
            发货区：
            <el-select v-model="deviceMonitorView.id" placeholder="请选择设备" @change="deviceMonitorView.deviceChange">
              <el-option v-for="com in deviceOptions" :value="com.id" :label="com.monitorName"
                         :key="com.id"></el-option>
            </el-select>
            <!--           <el-switch-->
            <!--               style="display: block"-->
            <!--               v-model="popoverManager.enabled"-->
            <!--               active-color="#67C23A"-->
            <!--               inactive-color="#909399"-->
            <!--               active-text="物流弹框">-->
            <!--            </el-switch>-->
          </div>
          <div style="margin-right: 15px; display: flex; align-items: center;">
            <span style="margin-right: 8px; font-size: 14px; color: #606266; white-space: nowrap;">弹窗字体:</span>
            <el-slider
              v-model="waybillFontSize"
              :min="60"
              :max="180"
              :step="10"
              style="width: 120px;"
              show-input
              :show-input-controls="false"
            ></el-slider>
          </div>
        </div>
      </span>

    </div>
    <div v-if="!newSys">
      <!-- 异常警报提示音 -->
      <div style="margin-left: 80px;">
        <el-button @click="changeView(1)">发货</el-button>
        <el-button @click="changeView(2)">多件发货</el-button>
        <el-button @click="changeView(8)">播种发货</el-button>
        <el-button @click="changeView(3)">异常查询</el-button>
        <el-button @click="changeView(6)">售后处理</el-button>
        <!--        <el-button @click="changeView(5)" v-if="false">仓管数据</el-button>-->
        <el-button @click="changeView(7)">快递扫描</el-button>
        <!--        <el-button @click="changeView(10)">测试功能</el-button>-->
        <!--       <el-button @click="showGlobalQuery()">发货记录</el-button>-->
      </div>

      <div v-if="view === 1" style="margin: 12px 0;">
        <div>
          <div style="font-weight: bolder;">
            扫码区

            <el-select style="margin-left: 8px;" v-model="matchChannel" placeholder="配单来源"
                       :class="matchChannel ? 'match_channel_success' : 'match_channel_danger'">
              <el-option v-for="chl in matchChannels"
                         :key="chl.value"
                         :label="chl.label"
                         :value="chl.value"></el-option>
            </el-select>
          </div>
          <p style="font-size: 12px; color: #909399;">注:
            配单来源必选(请登录再选择)，每次登录会自动清空，长时间不操作也会自动清空</p>
          <div style="display: flex; align-items: center; margin: 22px 0; justify-content: center;">

            <div style="display: flex; align-items: center; justify-content: center; width: 50%;">

              <el-input
                  style="margin-right: 12px;"
                  placeholder="扫描二维码"
                  :value="qrText"
                  @input="qrTextInput"
                  @keyup.enter.native="scanQrText"
                  clearable
                  :autofocus="true"
                  ref="inputRef"
              >
              </el-input>
            </div>
            <div>
              <el-button type="primary" @click="scanQrText"> 确认</el-button>
            </div>
          </div>

          <el-row>
            <el-button @click="getPrinters">刷新打印机</el-button>
            <el-select v-model="printerName" placeholder="请选择">
              <el-option
                  v-for="item in printers"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
              >
              </el-option>
            </el-select>
          </el-row>

          <div style="margin-top: 50px">
            <el-row>
              <el-col :span="8">
                <el-table
                    :data="qrTextQueue"
                    border
                    style="margin-top: 45px"
                    :row-class-name="highlightSelected"
                    @row-click="rowClick"
                >
                  <el-table-column prop="" label="批次" align="center" width="50">
                    <template slot-scope="{row}">
                      <el-radio :label="row.batchId" v-model="qrSelected" @change="handleQrChange">
                        <span> </span>
                      </el-radio>
                    </template>
                  </el-table-column>
                  <el-table-column prop="time" label="扫码时间" align="center">
                  </el-table-column>
                  <el-table-column prop="batchId" label="批次号" align="center"></el-table-column>
                  <el-table-column prop="qrText" label="条码" align="center">
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="16" style="margin-top: -23px;">
                <div style="display: flex; margin-left: 130px; color: grey; font-size: 15px;" class="delivery_advice">
                  <div>
                    换申通：{{ scanTextResult.stAdvised }}
                  </div>
                  <div>
                    换圆通：{{ scanTextResult.ytAdvised }}
                  </div>
                  <div>
                    换中通：{{ scanTextResult.ztAdvised }}
                  </div>
                  <div>
                    换顺丰：{{ scanTextResult.sfAdvised }}
                  </div>
                  <div>
                    换京东：{{ scanTextResult.jdAdvised }}
                  </div>
                </div>
                <el-radio-group v-model="filterSelected">
                  <el-radio :label="1">成功：{{ scanTextResult.success }}</el-radio>
                  <el-radio :label="5"><span
                      :class="scanTextResult.printMiss ? 'warning_text' : ''">未出单：{{
                      scanTextResult.printMiss
                    }}</span>
                  </el-radio>
                  <el-radio :label="2">失败：{{ scanTextResult.fail }}</el-radio>
                  <el-radio :label="4">重试：{{ scanTextResult.retry }}</el-radio>
                  <el-radio :label="3">总共：{{ scanTextResult.total }}</el-radio>
                </el-radio-group>

                <!--                <el-button style="margin-left: 12px;" size="mini" @click="refreshPrintResultForBatch">-->
                <!--                  重查打印状态-->
                <!--                </el-button>-->
                <el-button style="margin-left: 8px;" size="mini" @click="clearPrintResultResult">
                  清除打印缓存
                </el-button>

                <el-table
                    :data="filterPrintData"
                    border
                    style="width: 100%; margin-top: 19px"
                    :row-class-name="tableRowClassName"
                    @row-click="rowClick2"
                    @selection-change="sel => this.selections = sel"
                >
                  <el-table-column
                      align="center"
                      type="selection"
                      label="选择"
                      :selectable="reprintable"
                      width="42px"
                  >
                  </el-table-column>
                  <el-table-column prop="orderId" label="订单号" width="180" align="center">
                  </el-table-column>
                  <el-table-column prop="productPic" label="商品图片" align="center" v-if="false">
                    <template slot-scope="{row}">
                      <el-image class="img_box_mini" :src="row.productPic" :preview-src-list="[row.productPic]"
                                v-if="row.productPic">
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column prop="qrText" label="二维码" width="180" v-if="false">
                  </el-table-column>
                  <el-table-column prop="waybillId" label="物流单号" align="center">
                  </el-table-column>
                  <el-table-column prop="message" label="响应消息" align="center">
                    <template slot-scope="{ row }">
                      <div v-html="getMessage(row.message)"></div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="extraInfo" label="备注" align="center">
                    <template slot-scope="{ row }">
                      <span style="font-weight: bold; color: #E6A23C;">{{ row.extraInfo }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="printStatus" label="打印状态" align="center">
                    <template slot-scope="{row}">
                      <div v-if="row.printStatus && row.printStatus.status === 'success'">
                        <span style="color: #67C23A; font-size: 24px;"><i class="el-icon-success"></i></span>
                      </div>
                      <div
                          v-if="row.printStatus && (row.printStatus.status === 'failed' || row.printStatus.status === '打印失败')">
                        <el-tooltip placement="bottom">
                          <div slot="content">
                            <div>失败原因: {{ row.printStatus.msg }}</div>
                            <div>详细: {{ row.printStatus.detail }}</div>
                          </div>
                          <el-link type="danger" :underline="false">
                      <span style="font-size: 24px;">
                        <i class="el-icon-error"></i>
                      </span>
                          </el-link>
                        </el-tooltip>
                      </div>
                      <div v-if="row.printStatus && row.printStatus.status === 'canceled'">
                        <el-tooltip placement="bottom">
                          <div slot="content">
                            <div>信息: 已取消;{{ row.printStatus.msg }}</div>
                            <div>详细: {{ row.printStatus.detail }}</div>
                          </div>
                          <el-link type="info" :underline="false">
                          <span style="font-size: 24px;">
                            <i class="el-icon-warning"></i>
                          </span>
                          </el-link>
                        </el-tooltip>
                      </div>
                      <div v-if="row.printStatus && row.printStatus.status === 'timeout'">
                        <span style="color: #909399;"><i class="el-icon-warning"></i>请重新查询</span>
                        <el-button type="default" icon="el-icon-refresh-right" size="mini"
                                   @click="refreshPrintResultForRow(row)"></el-button>
                      </div>
                      <div v-if="!row.printStatus">
                        <span style="color: #909399;">未查询</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column property="nextStatus" label="重试状态" align="center">
                    <template slot-scope="{ row }">
                      <div v-if="row.nextStatus">
                        <el-tag type="info" effect="plain">
                          已重试
                        </el-tag>
                      </div>
                      <div v-else>-</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center">
                    <template slot="header" slot-scope="{ row }">
                      <el-button
                          type="warning"
                          size="mini"
                          @click="reprintWaybills"
                      >
                        批量重打
                      </el-button>
                    </template>
                    <template slot-scope="scope">
                      <el-button
                          type="warning"
                          size="mini"
                          icon="el-icon-printer"
                          v-if="scope.row.printData"
                          @click="reprint(scope.row)"
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>

          </div>
        </div>
      </div>

      <div v-if="view === 2">
        <!--        <div style="margin-left: 90px; display: flex; align-items: center; margin-top: 12px; margin-bottom: 12px;">-->
        <!--          <span style="font-weight: bolder; margin-right: 30px;">配单来源</span>-->
        <!--          <el-select v-model="matchChannel2" placeholder="配单来源" :class="matchChannel2 ? 'match_channel_success' : 'match_channel_danger'">-->
        <!--            <el-option v-for="chl in matchChannels"-->
        <!--                       :key="chl.value"-->
        <!--                       :label="chl.label"-->
        <!--                       :value="chl.value"></el-option>-->
        <!--          </el-select>-->
        <!--        </div>-->

        <el-row>
          <el-col :span="5"><p>选择客户</p></el-col>
          <el-col :span="6">
            <el-select @change="changeVip" v-model="vipName" placeholder="请选择" filterable>
              <el-option
                  v-for="item in vips"
                  :key="item.teamId"
                  :label="item.teamName"
                  :value="item.teamId"
              >
              </el-option>
            </el-select>
            <el-button type="success" icon="el-icon-refresh" @click="() => changeVip(vipName)">刷新</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5"><p>批次管理</p></el-col>
          <el-col :span="6">
            <el-select
                @change="changeTaskGroup"
                v-model="taskGroup"
                placeholder="请选择批次"
                value-key="id"
            >
              <el-option
                  v-for="item in taskGroups"
                  :key="item.id"
                  :label="item.title"
                  :value="item"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" @click="taskGroupDetail">
              批次发货
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" @click="createTaskGroup">
              创建批次
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" @click="createTaskGroupByScan">
              扫码创建
            </el-button>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" @click="createMultipleTaskGroupByOrderNum">
              按单创建
            </el-button>
          </el-col>
          <el-col :span="2">
            <el-button type="text" @click="showMultiSendResult">
              批次结果
            </el-button>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle">
          <el-col :span="5"><p>扫码搜索批次</p></el-col>
          <el-col :span="14">
            <el-input
                v-model="multiGroupQrText"
                placeholder="扫码搜索批次"
                @input="multiGroupQrTextInput"
                @keyup.enter.native="loadTaskGroupByQrText()"
                clearable
                @clear="changeVip(this.teamId, true)"
            ></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle">
          <el-col :span="5"><p>扫码搜索任务</p></el-col>
          <el-col :span="8">
            <el-input
                v-model="multipleSearchQrText"
                placeholder="扫码搜索任务"
                @input="multipleSearchQrTextInput"
                @keyup.enter.native="changeTaskGroup($event, true)"
                clearable
            ></el-input>
          </el-col>
          <el-col :span="3">
            <el-button type="text" icon="el-icon-edit" @click="toEditMultiPageSize">
              <span style="font-size: 16px;">{{ multiPageSize }}</span>
            </el-button>
            条/页
          </el-col>
          <el-col :span="5">待处理批次{{ taskGroups.length - 1 }}</el-col>
        </el-row>
        <div v-if="multipleOrders && multipleOrders.length">
          <el-card v-for="(order, idx) in multipleOrders" :key="order.order_id">
            <div slot="header" class="clearfix">
              <span>序列号: {{ order.order_id }}</span>
              <span>| 总数:
                <span style="color: red; font-size: xxx-large;">
                  {{ order.combo_num }}
                </span>
              </span>
              <span>| 标志: <span v-html="transformDeliver(order.deliver)"></span></span>
              <el-button
                  @click="sendOrder(order, idx)"
                  style="float: right; padding: 3px 0"
                  type="text"
              >打印
              </el-button>
              <div>
                备注：{{ order.seller_remark }}
              </div>
            </div>
            <div
                v-for="child in order.children"
                :key="child.order_id"
                class="text item"
            >
              <el-row>
                <el-col :span="12">
                  <el-image
                      style="width: 100px; height: 100px"
                      :src="child.product_pic"
                      :preview-src-list="[child.product_pic]"
                  ></el-image>
                </el-col>
                <el-col :span="12">
                  <div>{{ child.product_name }}</div>
                  <div>{{ child.code }}</div>
                  <div>{{ child.specs }} * <span
                      style="font-weight: bold; font-size: 20px; color: orangered;">{{ child.combo_num }}</span></div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </div>
        <div v-else>
          <el-card>
            暂无记录
          </el-card>
        </div>
      </div>

      <div v-if="view === 3">
        <el-row>
          <el-col :span="4"><p>条码</p></el-col>
          <el-col :span="9">
            <el-input
                placeholder="条码/物流号码"
                :value="qrCode"
                @input="qrCodeInput"
                @keyup.enter.native="queryByQrText"
                clearable
            >
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="queryByQrText"> 确认</el-button>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" @click="reprintByQrCode">
              重打面单
            </el-button>
          </el-col>
          <el-col :span="2"> {{ recordsNum }}件</el-col>

          <el-col :span="2">
            <el-button type="warning" @click="batchReprint">批量重打</el-button>
          </el-col>
        </el-row>
        <div>
          <div>
            <el-table
                :data="records"
                border
                style="width: 100%"
                :row-class-name="tableRowclassName_inquire"
                @selection-change="handleSelectionChange"
            >
              <el-table-column align="center" type="selection" width="55">
              </el-table-column>
              <el-table-column prop="createdTime" label="入库时间">
              </el-table-column>
              <el-table-column prop="lastUpdateTime" label="更新时间">
              </el-table-column>
              <el-table-column prop="orderId" label="订单号"></el-table-column>
              <el-table-column prop="waybillId" label="物流单号">
              </el-table-column>
              <el-table-column prop="orderStatus" label="订单状态">
              </el-table-column>
              <el-table-column prop="errorMsg" label="状态描述">
              </el-table-column>
              <el-table-column prop="logisticsStatus" label="揽收状态">
              </el-table-column>
              <el-table-column prop="packerName" label="打包人">
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                      size="mini"
                      icon="el-icon-warning"
                      @click="errOrder(scope.row)"
                  ></el-button>
                  <el-button
                      type="warning"
                      size="mini"
                      icon="el-icon-printer"
                      @click="reprintWaybill(scope.row.waybillId)"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <div v-if="view === 4">
        <el-row>
          <el-button @click="printTest">测试打印</el-button>
        </el-row>
        <el-row>
          <el-button @click="skuTest">测试sku</el-button>
        </el-row>
        <el-row>
          扫码测试：
          <el-input v-model="barCode"
                    placeholder="请扫码（中文输入法扫码测试）"
                    @keyup.native="handleKeyUp"
                    clearable></el-input>
        </el-row>
        <!-- 新增一个扫码测试模块 -->
        <el-row>
          <!--          <el-button @click="testInsert" >测试插入</el-button>-->
          <el-col :span="6"><p style="margin-left: 150px">扫码区</p></el-col>
          <el-col :span="14">
            <el-input
                placeholder="扫描二维码"
                :value="qrText"
                @input="qrTextInput"
                @keyup.enter.native="scanQrText2"
                clearable
                :autofocus="true"
            >
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="scanQrText2"> 确认</el-button>
          </el-col>
        </el-row>
        <div v-for="i in 10" :key="i">
          <div style="border: 1px solid red; height: 300px;">
          </div>
        </div>
      </div>

      <div v-if="view === 5">
        <el-row>
          <el-col :span="3">
            <p>时间选择器:</p>
          </el-col>
          <el-col :span="12">
            <el-date-picker
                v-model="timeRange"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="3">
            <p>客户选择:</p>
          </el-col>
          <el-col :span="6">
            <el-select @change="changeVip" v-model="vipName" placeholder="请选择" filterable>
              <el-option
                  v-for="item in vips"
                  :key="item.teamId"
                  :label="item.teamName"
                  :value="item.teamId"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px; border: 1px solid #000000">
          <el-col :span="6">
            <div>发货导表</div>
          </el-col>
          <el-col :span="6">
            <el-select v-model="platform" placeholder="请选择">
              <el-option label="抖音" :value="0"></el-option>
              <el-option label="快手" :value="1"></el-option>
              <el-option label="淘宝" :value="7"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6"> 包含时间及客户</el-col>
          <el-col :span="6">
            <el-button @click="toDown(0)">导出</el-button>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px; border: 1px solid #000000">
          <el-col :span="6">
            <div>实时库存</div>
          </el-col>
          <el-col :span="6">
            <el-checkbox v-model="allUser">所有客户</el-checkbox>
          </el-col>
          <el-col :span="6"> 选择客户</el-col>
          <el-col :span="6">
            <el-button @click="toDown(1)">导出</el-button>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px; border: 1px solid #000000">
          <el-col :span="6">
            <div>上下架记录</div>
          </el-col>
          <!--                <el-col :span="3">-->
          <!--                    <el-checkbox v-model="allUser">所有客户</el-checkbox>-->
          <!--                </el-col>-->
          <el-col :span="6">
            <el-select v-model="upType" placeholder="请选择">
              <el-option label="所有" :value="null"></el-option>
              <el-option label="剩货上架" :value="0"></el-option>
              <el-option label="售后上架" :value="1"></el-option>
              <el-option label="捡货归还" :value="2"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6"> 包含时间及客户</el-col>
          <el-col :span="6">
            <el-button @click="toDown(2)">导出</el-button>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px; border: 1px solid #000000">
          <el-col :span="6">
            <div>当天发货结束</div>
          </el-col>
          <el-col :span="12">
            <div>&nbsp;</div>
          </el-col>
          <el-col :span="6">
            <el-button @click="toDown(3)">确定</el-button>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px; border: 1px solid #000000">
          <el-col :span="6">
            <div>调度单导出</div>
          </el-col>
          <el-col :span="6">
            <!--                    <el-checkbox v-model="allUser">所有客户</el-checkbox>-->
          </el-col>
          <el-col :span="6"> 选择客户及时间</el-col>
          <el-col :span="6">
            <el-button @click="toDown(4)">导出</el-button>
          </el-col>
        </el-row>
      </div>

      <div v-if="view === 6">
        <div>
          <el-switch v-model="enableGlobalScanListener" @change="() => updateScannerListeners()"></el-switch>
          自动物流扫描识别
        </div>
        <el-row>
          <el-col :span="3">
            <p>物流单号/手机</p>
          </el-col>
          <el-col :span="5">
            <el-input
                placeholder="物流单号/手机号"
                v-model="qrText"
                @keyup.native="handleWaybillKeyUp"
                clearable
                ref="waybillInputRef"
            >
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button @click="waybillScan($event, null, true)">确认</el-button>
          </el-col>
          <el-col :span="2">
            <p>客户:</p>
          </el-col>
          <el-col :span="4">
            <el-select @change="changeVip" v-model="vipName" placeholder="请选择" filterable clearable>
              <el-option
                  v-for="item in vips"
                  :key="item.teamId"
                  :label="item.teamName"
                  :value="item.teamId"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-switch
                style="display: block"
                v-model="labelPrinter"
                @change="labelPrinterChange"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="本地"
                inactive-text="云">
            </el-switch>
          </el-col>
          <el-col :span="3">
            <el-select
                @change="changePrinter"
                v-model="printerCode"
                placeholder="选择标签机"
            >
              <el-option
                  v-for="item in printerCodes"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <!-- 拦截件模式才有 -->
        <div style="margin-bottom: 12px" v-if="workMode===1">
          <el-row>
            <el-col :span="3">
              <p>原面单ID:</p>
            </el-col>
            <el-col :span="6">
              <el-input v-model="originWaybillId" placeholder="原面单ID(处理换单)"
                        @keyup.enter.native="showOriginWaybill"
                        clearable></el-input>
            </el-col>
            <!-- 占位 -->
            <el-col :span="2"></el-col>
          </el-row>
        </div>

        <el-row>
          <el-col :span="3"> 处理内容</el-col>
          <el-col :span="6">
            <el-select v-model="workMode" placeholder="处理内容">
              <el-option
                  v-for="item in workModes"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="3">
            <div>转异常处理</div>
          </el-col>
          <el-col :span="4">
            <el-select v-model="unusual" placeholder="异常原因">
              <el-option
                  v-for="item in unusuals"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-button type="danger" @click="toUnusual">确认</el-button>
          </el-col>
          <el-col :span="3">
            <after-sale-order-sync-btn></after-sale-order-sync-btn>
          </el-col>

        </el-row>
        <el-popover
            refs="myPopover"
            trigger="manual"
            popper-class="waybill-popover"
            v-model="popVisible"
            :visible-arrow="false"
            :style="`width: ${waybillPopoverWidth}; max-width: ${waybillPopoverWidth};`"
        >
          <div style="text-align: center; background: yellow; overflow: hidden; box-sizing: border-box; width: 100%;">
          <span :style="`font-size: clamp(40px, 8vw, ${waybillFontSize}px); color: black; white-space: nowrap; display: inline-block; max-width: 100%; overflow: hidden; text-overflow: ellipsis;`">{{
              scanWaybillId
            }}</span>
          </div>
        </el-popover>
        <el-row>
          <div v-if="workMode === 0 || workMode === 3">
            <el-card v-if="afterList && afterList.length">
              <div slot="header" v-if="afterList && afterList.length > 1">
                <div v-if="workMode === 0">
                  <el-button type="primary" @click="confirmRecWholePack(0)">整包退款收货
                  </el-button>
                  <el-button type="info" @click="confirmRecWholePack( 2)"
                  >整包仅收货
                  </el-button>
                  <el-button @click="reprintLabelWholePack">整包重打</el-button>
                </div>
              </div>
              <el-card v-for="(order, idx) in afterList" :key="order.aftersaleId">
                <div slot="header" class="clearfix">
                  <span> {{ order.applyTime }}</span>
                  <span>| {{ order.reasonDesc }}</span>
                  <span>| {{ order.refundStatusDesc }}</span>
                  <span>| {{ order.shopName }}</span>
                  <span v-if="order.refundKind">| <span
                      style="font-weight: bold; color: #E6A23C;">{{ order.refundKindDesc }}</span></span>
                </div>
                <div
                    v-for="child in order.items"
                    :key="child.orderId"
                    class="text item"
                >
                  <el-row>
                    <el-col :span="9">
                      <img
                          :src="child.productVo.lbImages[0].url"
                          style="width: 334px"
                      />
                    </el-col>
                    <el-col :span="9">
                      <div class="split" v-if="child.platform === 5">
                        <div>视频号订单号: {{ child.pid }}</div>
                        <div>毅播订单号: {{ child.orderId }}</div>
                      </div>
                      <div class="split" v-else-if="child.platform === 17">
                        <div>有赞订单号: {{ child.pid }}</div>
                        <div>退款子订单号: {{ child.orderId }}</div>
                      </div>
                      <div class="split" v-else-if="child.platform === 18">
                        <div>小红书订单号: {{ child.pid }}</div>
                        <div>毅播订单号: {{ child.orderId }}</div>
                      </div>
                      <div class="split" v-else>{{ child.orderId }}</div>
                      <div class="split">标题：
                        <span v-html="getItemProductName(child.productVo.name)"></span>
                      </div>
                      <div class="split">
                        商品编码：
                        <span style="font-weight: bold; color: red; font-size: xx-large;">
                          {{ order.orderVo ? order.orderVo.code : "" }}
                        </span>
                      </div>
                      <div class="split">
                        规格：
                        {{ child.productVo.specs.name }} *
                        <span style="font-weight: bold; color: red; font-size: 26px;">
                          {{ child.num }}
                        </span>
                      </div>

                      <div class="split">
                        备注: {{ order.recordItems[0].remark }}
                      </div>
                      <div class="split">
                        客服备注:
                        {{ order.orderVo ? order.orderVo.seller_remark : "" }}
                      </div>
                      <div v-if="getItemOrderVoView(child).visible" class="split">
                        实付金额：<span
                          style="font-weight: bold; color: #67C23A;">{{ getItemOrderVoView(child).payAmount }}</span>
                        <span style="margin: 0 8px;">/</span>
                        退款金额：<span
                          style="font-weight: bold; color: #F56C6C;">{{ getItemOrderVoView(child).refundAmount }}</span>
                      </div>
                      <div class="split">
                        <el-link type="primary" @click="() => toLoadMorePictures(child)">更多图片</el-link>
                      </div>
                    </el-col>
                    <el-col :span="6" v-if="workMode === 0">

                      <div class="split">
                        <el-button type="primary" @click="confirmRec(order, child, 0)"
                        >退款收货
                        </el-button>
                        <!-- <el-button type="primary" @click="confirmRec(order, child, 2)"
                          >换货转退款(需后台确认)</el-button
                        > -->
                      </div>
                      <div class="split">
                        <el-button type="success" @click="confirmRec(order, child, 1)"
                        >换货收货
                        </el-button>
                      </div>
                      <div class="split">
                        <el-button type="info" @click="confirmRec(order, child, 2)"
                        >仅收货
                        </el-button>
                      </div>

                      <div class="split">
                        <el-button @click="realSkuSelect(order)" style="margin-left: 12px"
                        >重打标签(换规格)
                        </el-button
                        >
                      </div>
                      <div class="split"></div>
                      <div class="split">
                        <el-button @click="reprintLabel(order, child)">重打标签</el-button>
                      </div>
                      <div class="split">
                        <el-button @click="reprintDefect(order,child)">次品重打</el-button>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </el-card>
          </div>
          <div>
            <el-card
                v-if="workMode === 1"
                v-for="(child, idx) in afterList"
                :key="child.order_id"
            >
              <el-row>
                <el-col :span="9">
                  <img :src="child.product_pic" style="width: 334px"/>
                </el-col>
                <el-col :span="9">
                  <!--                <div class="split">{{ child.tik_shop_id }}</div>-->
                  <div class="split" v-if="child.platform === 5">
                    <div>视频号订单号: {{ child.pid }}</div>
                    <div>毅播订单号: {{ child.order_id }}</div>
                  </div>
                  <div class="split" v-else>{{ child.order_id }}</div>
                  <div class="split">
                    <span v-html="getItemProductName(child.product_name)"></span>
                  </div>
                  <div>
                    <span style="font-weight: bold; color: red; font-size: xx-large;">{{ child.code }}</span>
                  </div>
                  <div class="split">
                    {{ child.specs }} * {{ child.combo_num }}
                  </div>

                  <div class="split">备注: {{ child.custom_remark }}</div>
                  <div class="split">客服备注: {{ child.seller_remark }}</div>
                  <div class="split">拦截件备注: {{ child.interceptRemark }}</div>
                  <div class="split">
                    <el-button type="default" @click="addInterceptRemark(child)">拦截件备注</el-button>
                  </div>
                  <div class="split" style="white-space: nowrap;margin-left: 90px" v-if="false">
                    <span>换单ID:</span>
                    <el-input v-model="changeWaybillId" placeholder="实际签收的单号" clearable></el-input>
                  </div>
                  <div class="split">
                    <el-button type="primary" @click="reprintIntercept(child)">签收/重印标签</el-button>
                  </div>
                  <div class="split">
                    <el-button type="default" @click="realSkuSelect(child)">重印标签(换规格)</el-button>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </div>
        </el-row>
      </div>

      <div v-if="view === 7">
        <div>
          <el-row style="margin-top: 20px">
            <el-col :span="3" v-if="packageWaybillMode === 0"><p style="margin-left: 0px">包裹扫码区</p></el-col>
            <el-col :span="3" v-if="packageWaybillMode === 1"><p style="margin-left: 0px">物流单扫描</p></el-col>
            <el-col :span="6" v-if="packageWaybillMode === 0">
              <el-input
                  placeholder="扫描物流单"
                  :value="packageWaybill"
                  @input="packageWaybillInput"
                  @keyup.enter.native="scanPackageWaybill"
                  clearable
                  :autofocus="true"
              >
              </el-input>
            </el-col>
            <el-col :span="2" v-if="packageWaybillMode === 0">
              <el-button type="primary" @click="scanPackageWaybill">确认</el-button>
            </el-col>
            <el-col :span="5" v-if="packageWaybillMode === 1">
              <el-input
                  placeholder="扫描物流单"
                  :value="packageWaybill"
                  @input="packageWaybillInput"
                  @keyup.enter.native="packageWaybillQuery()"
                  clearable
                  :autofocus="true"
              >
              </el-input>
            </el-col>
            <el-col :span="5" v-if="packageWaybillMode === 1" style="margin-left: 5px;">
              <el-date-picker
                  v-model="dates"
                  :picker-options="pickerOptions2"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  style="width: 350px"
                  align="right"
              />
            </el-col>
            <el-col :span="2" v-if="packageWaybillMode === 1" style="margin-left: 120px">
              <el-button type="primary" @click="packageWaybillQuery()">查询</el-button>
            </el-col>
            <el-col :span="6" style="margin-left: 0px;">
              模式：
              <el-select v-model="packageWaybillMode" placeholder="请选择模式">
                <el-option :value="0" label="扫码"></el-option>
                <el-option :value="1" label="查询"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-left: 22px;">
            <el-col :span="6" style="margin-left: 0px;">
              快递员：
              <el-select v-model="courierUserSelected" placeholder="快递员" @change="handleCourierChange">
                <el-option :value="1" label="屏山-快递员"></el-option>
                <el-option :value="2" label="市桥-快递员"></el-option>
              </el-select>
            </el-col>
            <el-col :span="3" style="margin-left: 0px;" v-if="packageWaybillMode === 1">
              <el-button @click="exportCourierScanRecords" type="success">导出</el-button>
            </el-col>
          </el-row>
          <div style="margin-top: 10px" v-if="packageWaybillMode === 0">
            <el-row>
              <el-col :span="22">
                <el-table
                    :data="packageWaybillList"
                    border
                    style="width: 100%; margin-top: 26px"
                >
                  <el-table-column prop="createdTime" label="时间" align="center"></el-table-column>
                  <el-table-column prop="waybillId" label="物流单号" align="center"></el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
          <div style="margin-top: 10px" v-if="packageWaybillMode === 1">
            <el-row>
              <el-col :span="22">
                <el-table
                    :data="expressDeliveryList"
                    v-loading="expressDeliveryLoading"
                    border
                    style="width: 100%; margin-top: 26px"
                >
                  <el-table-column prop="createdTime" label="时间" align="center"></el-table-column>
                  <el-table-column prop="waybillId" label="物流单号" align="center"></el-table-column>
                </el-table>
                <el-pagination
                    @current-change="handleExpressDeliveryPageChange"
                    :current-page.sync="pageInfo.page"
                    :page-size="pageInfo.size"
                    layout="total, prev, pager, next"
                    :total="pageInfo.total">
                </el-pagination>

              </el-col>
            </el-row>

          </div>
        </div>
      </div>

      <div v-if="view === 8">
        <el-row type="flex" justify="center">
          <div style="margin-top: 30px; font-weight: bold; font-size: x-large">
            播种墙：{{ sowingWall.id ? `【${sowingWall.qrCode}】` : '您尚未扫描播种墙二维码' }}
            <el-button type="text" @click="toScanSowingQrCode">去扫码</el-button>
            <el-button type="success" @click="loadSowingCells" v-if="sowingWall.id">刷新</el-button>
            <el-button type="primary" @click="batchSowingDelivery()" v-if="sowingWall.id">批量发货</el-button>
          </div>
        </el-row>
        <div>
          <el-row v-if="showScanSowingWall" justify="center" type="flex">
            <el-col :span="6" style="margin-left: 100px">
              <el-input
                  v-model="sowingWallQrText"
                  placeholder="扫描播种墙二维码"
                  @input="sowingWallQrTextInput"
                  @keyup.enter.native="scanSowingWallQrText"
                  clearable
                  ref="sowingWallScanner"
              ></el-input>
            </el-col>
            <el-col :span="1" style="margin-left: 12px">
              <el-button type="default" @click="scanSowingWallQrText">确认</el-button>
            </el-col>
            <el-col :span="3">
              <el-button style="margin-left: 0px;" type="text" v-if="sowingWall && sowingWall.id"
                         @click="hideSowingWallScanner">收起
              </el-button>
            </el-col>
          </el-row>

          <div style="margin-top: 20px;">
            <!--            <div style="margin-left: 12px; display: flex; align-items: center; margin-top: 12px; margin-bottom: 12px;">-->
            <!--              <span style="font-weight: bolder; margin-right: 12px;">配单来源</span>-->
            <!--              <el-select v-model="matchChannel2" placeholder="配单来源" :class="matchChannel2 ? 'match_channel_success' : 'match_channel_danger'">-->
            <!--                <el-option v-for="chl in matchChannels"-->
            <!--                           :key="chl.value"-->
            <!--                           :label="chl.label"-->
            <!--                           :value="chl.value"></el-option>-->
            <!--              </el-select>-->
            <!--            </div>-->
            <el-row>
              <el-col :span="6" style="margin-right: 20px;">
                <span style="color: #606266; margin-right: 5px;">团队选择</span>
                <el-select v-model="sowingWall.teamId" placeholder="请选择" filterable>
                  <el-option
                      v-for="item in vips"
                      :key="item.teamId"
                      :label="item.teamName"
                      :value="item.teamId"
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-input
                    v-model="multipleQrText"
                    placeholder="请扫码"
                    @input="multipleQrTextInput"
                    @keyup.enter.native="scanMultipleQrText"
                    clearable
                    ref="multipleQrTextScanner"
                    :disabled="!sowingWall.teamId || !sowingWall.id"
                ></el-input>
              </el-col>
              <el-col :span="2">
                <el-button type="default" @click="scanMultipleQrText">确认</el-button>
              </el-col>
            </el-row>
          </div>

          <el-row v-if="columns && columns.length">
            <el-divider content-position="left">播种墙</el-divider>
            <el-table
                :data="columns"
                style="width: 100%; margin-top: 20px;"
                :cell-class-name="getCellClassName"
                border>
              <el-table-column label="行/列" type="index" :index="indexMethod" align="center" width="100px">
              </el-table-column>
              <el-table-column v-for="(colNum, index) in columns[0].length" :label="'C'+ colNum" align="center">
                <template slot-scope="scope">
                  <div
                      :class="scope.row[index].status === 1 ? 'warning-cell' : scope.row[index].status === 2 ? 'success-cell' : ''">
                    <div style="font-weight: bold;">{{ scope.row[index].qrCode }}</div>
                    <!--                <div>[{{scope.row[index].rowNum}},{{scope.row[index].columnNum}}]</div>-->
                    <div>{{ scope.row[index].dispatchedNum }} / {{ scope.row[index].totalNum }}</div>
                    <div>
                      <el-button v-if="scope.row[index].status > 0" type="text"
                                 @click="toReleaseSowingCell(scope.row[index])">释放
                      </el-button>
                    </div>
                    <div>
                      <el-button type="text" @click="showOrdersInCell(scope.row[index])">查看</el-button>
                    </div>
                    <div>
                      <el-button v-if="scope.row[index].status === 2 && false" type="default" size="small"
                                 @click="toSowingDeliver(scope.row[index])">发货
                      </el-button>
                    </div>
                    <!--                  <div v-if="scope.row[index].status > 0">{{scope.row[index].dispatchedNum}} / {{scope.row[index].totalNum}}</div>-->
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-row>

          <div>
            <el-divider content-position="left">播种发货记录</el-divider>
            <el-form :model="sowingQuery" :inline="true" style="display: flex; flex-wrap: wrap;">
              <el-form-item class="deliver-taq">
                <employee-selector
                    placeholder="打包员工（输入名字）"
                    size="small"
                    @employeeChange="(val, emp) => this.$set(this.sowingQuery, 'packer', val)"
                >
                </employee-selector>
              </el-form-item>
              <el-form-item class="deliver-taq">
                <el-select
                    v-model="sowingQuery.hasPrinted"
                    placeholder="是否出单"
                    size="small"
                    clearable
                >
                  <el-option value="false" label="未出单"/>
                  <el-option value="true" label="已出单"/>
                </el-select>
              </el-form-item>
              <el-form-item class="deliver-taq">
                <el-select
                    v-model="sowingQuery.deliveryStatus"
                    placeholder="是否发货成功"
                    size="small"
                    clearable
                >
                  <el-option value="[6, 7, 8, 11, 12]" label="发货失败"/>
                  <el-option value="[10]" label="发货成功"/>
                </el-select>
              </el-form-item>
              <el-form-item class="deliver-taq">
                <el-select v-model="sowingQuery.timeType" style="width: 100px;" size="small">
                  <el-option :value="1" label="配单时间"></el-option>
                  <el-option :value="2" label="发货时间"></el-option>
                </el-select>
                <el-date-picker
                    v-model="sowingQuery.dates"
                    :picker-options="pickerOptions2"
                    style="margin-left: -2px"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    size="small"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    align="right"
                />
              </el-form-item>
              <el-form-item class="deliver-taq">
                <el-button type="primary" icon="el-icon-search" size="small" @click="loadSowingRecords()">查询
                </el-button>
              </el-form-item>
            </el-form>
            <el-table
                v-loading="sowingData.loading"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                :data="sowingData.data"
                class="table_box"
                size="small"
                border
                style="width: 100%"
                @selection-change="sel => this.$set(sowingData, 'selections', sel)"
            >
              <el-table-column type="selection" label="选择" align="center">
              </el-table-column>
              <el-table-column
                  prop="logisticsTime"
                  label="发货时间"
                  align="center"
              />
              <el-table-column
                  align="center"
                  prop="teamName"
                  label="团队"
              />
              <el-table-column prop="sowingCellCode" label="播种框" align="center"/>
              <el-table-column prop="actionDescribe" label="状态" align="center"/>
              <el-table-column label="商品详情" property="product" align="center" width="400">
                <template slot-scope="{ row }">
                  <div v-if="row.product && row.product.length">
                    <div v-for="(prod, index) in row.product" :key="index">
                      <div style="display: flex">
                        <div>
                          <el-image
                              class="img_box_tiny"
                              :src="prod.image"
                              :preview-src-list="[prod.image]"
                          >
                          </el-image>
                        </div>
                        <div style="margin-left: 5px; font-size: 12px;">
                          <span>{{ prod.productName }}</span><br/>
                          <span class="sku-code" v-if="prod.snCode">{{ prod.snCode }}<br/></span>
                          {{ prod.specs }};
                          <span><i class="el-icon-close"></i>{{ prod.num || 1 }}</span>
                        </div>
                      </div>
                      <div class="dashed_line" v-if="index < row.product.length - 1">
                      </div>
                    </div>
                  </div>
                  <div v-else>---</div>
                </template>
              </el-table-column>
              <el-table-column prop="waybillId" label="物流单号" align="center">
              </el-table-column>
              <el-table-column
                  prop="packerName"
                  label="打包人"
                  align="center"
              />
              <el-table-column prop="errorMsg" label="备注" align="center"/>
              <el-table-column prop="printCount" label="出单记录" align="center">
                <template slot-scope="{ row }">
                  {{ row.printCount || 0 }}
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="110">
                <template slot="header" slot-scope="{ row }">
                  <el-button type="warning" size="small" @click="batchSowingReprintBySelections">批量重打</el-button>
                </template>
                <template slot-scope="scope">
                  <el-link type="primary" :underline="false" @click="sowingReprint(scope.row)"
                           :disabled="!scope.row.packer">重打
                  </el-link>
                </template>
              </el-table-column>
            </el-table>
            <div style="display: flex; justify-content: flex-start;">
              <el-pagination
                  :current-page="sowingQuery.page"
                  :page-size="sowingQuery.size"
                  :total="sowingQuery.total"
                  style="margin: 12px 0;"
                  layout="prev, pager, next, ->, total"
                  @current-change="val => this.loadSowingRecords(val - 1)"
              />
            </div>
          </div>
        </div>
      </div>

      <div v-if="view === 10">
        <div>
          <div style="font-weight: bolder;">
            扫码区
          </div>
          <div style="display: flex; align-items: center; margin: 22px 0; justify-content: center;">

            <div style="display: flex; align-items: center; justify-content: center; width: 50%;">
              <el-select v-model="randomScanView.teamId" disabled>
                <el-option :value="5164022" label="SIVI熙薇"></el-option>
              </el-select>
              <el-input
                  style="margin-right: 12px;"
                  placeholder="扫描二维码"
                  :value="randomScanView.qrText"
                  @input="randomScanView.onInput"
                  @keyup.enter.native="randomScanView.onScan"
                  clearable
                  :autofocus="true"
              >
              </el-input>
            </div>
            <div>
              <el-button type="primary" @click="randomScanView.onScan"> 确认</el-button>
            </div>
          </div>

          <el-row>
            <el-button @click="getPrinters">刷新打印机</el-button>
            <el-select v-model="printerName" placeholder="请选择">
              <el-option
                  v-for="item in printers"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
              >
              </el-option>
            </el-select>
          </el-row>

          <!--  扫码结果  -->
          <div>

          </div>
        </div>
      </div>
      <el-dialog
          :title="'【' + sowingCell.qrCode + '】播种发货: 共[' + sowingCell.totalNum +']件'"
          :visible.sync="sowingDeliveryScanDialog"
          :close-on-click-modal="false"
      >
        <el-row>
          <el-col :span="6">
            <el-input v-model="sowingProductQrText"
                      placeholder="请扫框内的所有商品条码"
                      @input="sowingProductQrTextInput"
                      @keyup.enter.native="scanSowingProductQrText"
                      ref="scanSowingProductScanner"
                      clearable
            ></el-input>
          </el-col>
          <el-col :span="2" style="margin-left: 12px;">
            <el-button type="default" @click="scanSowingProductQrText">确认</el-button>
          </el-col>
        </el-row>
        <el-table :data="sowingProductQrTexts" style="margin-top: 20px" border>
          <el-table-column property="scanTime" label="时间" align="center"></el-table-column>
          <el-table-column property="qrText" label="二维码" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{row}">
              <el-button type="text" @click="doDeleteSowingProductQrText(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="sowingDeliveryScanDialog = false">取 消</el-button>
          <el-button type="primary" @click="multipleOrderSendBySowing">发 货</el-button>
        </div>
      </el-dialog>

      <el-dialog title="创建批次" :visible.sync="taskGroupCreateViewable">
        <el-select
            @change="changeTaskSku"
            v-model="taskSku"
            placeholder="请选择批次款式"
            value-key="skuId"
            multiple
        >
          <el-option
              v-for="item in skuList"
              :key="item.skuId"
              :label="item.product_name"
              :value="item"
              style="height: 100px"
          >
            <div class="text item">
              <el-row>
                <el-col :span="12">
                  <img
                      :src="item.product_pic"
                      style="width: 100px; height: 100px"
                  />
                </el-col>
                <el-col :span="12">
                  <div>{{ item.product_name }}</div>
                  <div>{{ item.specs }}</div>
                </el-col>
              </el-row>
            </div>
          </el-option>
        </el-select>

        <el-input
            placeholder="扫二维码创建"
            v-model="qrTextInfo"
            @keyup.enter.native="getSkuFromQrText"
            clearable
            ref="inputRef"
        >
        </el-input>

        <el-row v-for="item in taskSku">
          <el-col>
            <div>产品名称: {{ item.product_name }} ||| 产品规格: {{ item.specs }} ||| 数量:1</div>
          </el-col>
        </el-row>

        <div slot="footer" class="dialog-footer">
          <el-button @click="taskGroupCreateViewable = false">取 消</el-button>
          <el-button type="primary" @click="toConfirmCreate">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="商品信息" :visible.sync="productDialogVisible">
        <div style="height: 460px; width: 900px">
          <div style="float: left">
            <img
                :src="productItem.image"
                style="
              margin-left: 20px;
              margin-right: 20px;
              width: 350px;
              height: 450px;
            "
            />
          </div>

          <div class="productItem_div" style="float: left; text-align: left">
            <div>
              商品名称：<span>{{ productItem.productName }}</span>
            </div>
            <div>
              商品编码：<span>{{ productItem.snCode }} </span>
            </div>
            <div>
              商品规格：<span>{{ productItem.specs }} </span>
            </div>
            <div>
              店铺名称：<span>{{ productItem.shopName }} </span>
            </div>
            <div>
              商品库存：<span>{{ productItem.stock }} </span>
            </div>
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="todoProduct">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="规格选择" :visible.sync="skuListDialogVisible" width="800px">

        <el-row>
          <el-col :span="6">
            <el-input v-model="keyword"
                      placeholder="输入品名/货号"
                      @keyup.native.enter="doKeywordSearchForStock"
                      class="input-item-short"
            ></el-input>
          </el-col>
          <el-col :span="3">
            <el-select v-model="update_sku_platform">
              <el-option v-for="plat in PLATFORMS" :value="plat.value" :label="plat.label"
                         :key="plat.value"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="doKeywordSearchForStock">搜索</el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="success" @click="confirmSku">确认选择</el-button>
          </el-col>
        </el-row>
        <el-tabs v-model="activeTab" type="card">
          <el-tab-pane label="从库存搜索" name="first">
            <el-row>
              <el-table
                  v-loading="skuListLoading"
                  :data="skuList1"
                  border
                  height="450px"
                  style="width: 100%"
              >
                <el-table-column
                    label="选择" align="center">
                  <template slot-scope="{row}">
                    <el-radio v-model="skuSelected" :label="row.skuId"><span v-text=" "></span>
                    </el-radio>
                  </template>
                </el-table-column>
                <el-table-column label="商品图片" align="center">
                  <template slot-scope="props">
                    <!--                  <img :src="props.row.image" class="img_box_mini"/>-->
                    <el-image
                        class="img_box_mini"
                        :src="props.row.image"
                        :preview-src-list="[props.row.image]"
                    ></el-image>
                  </template>
                </el-table-column>
                <el-table-column label="商品名称" prop="productName" align="center">
                </el-table-column>
                <el-table-column label="规格" prop="specs" align="center">
                </el-table-column>
                <el-table-column label="货号" prop="snCode" align="center">
                </el-table-column>
                <el-table-column label="商家名称" prop="shopName" align="center">
                </el-table-column>
                <el-table-column label="库存" prop="stock" align="center">
                </el-table-column>
                <el-table-column label="可用库存" prop="availableStock" align="center">
                </el-table-column>
              </el-table>
            </el-row>
            <el-row>
              <el-pagination
                  @current-change="handleDialogCurrentChange"
                  :current-page.sync="dialog_page"
                  :page-size="dialog_size"
                  layout="total, prev, pager, next"
                  :total="dialog_total">
              </el-pagination>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="从订单搜索" name="second">
            <el-row>
              <el-table
                  v-loading="skuListLoading2"
                  :data="skuList2"
                  border
                  height="450px"
                  style="width: 100%"
              >
                <el-table-column
                    label="选择" align="center">
                  <template slot-scope="{row}">
                    <el-radio v-model="skuSelected" :label="row.skuId"><span v-text=" "></span>
                    </el-radio>
                  </template>
                </el-table-column>
                <el-table-column label="商品图片" align="center">
                  <template slot-scope="props">
                    <!--                  <img :src="props.row.image" class="img_box_mini"/>-->
                    <el-image
                        class="img_box_mini"
                        :src="props.row.image"
                        :preview-src-list="[props.row.image]"
                    ></el-image>
                  </template>
                </el-table-column>
                <el-table-column label="商品名称" prop="productName" align="center">
                </el-table-column>
                <el-table-column label="规格" prop="specs" align="center">
                </el-table-column>
                <el-table-column label="货号" prop="snCode" align="center">
                </el-table-column>
                <el-table-column label="商家名称" prop="shopName" align="center">
                </el-table-column>
              </el-table>
            </el-row>
            <el-row>
              <el-pagination
                  :current-page.sync="dialog_page2"
                  :page-size="dialog_size2"
                  layout="total, prev, pager, next"
                  :total="dialog_total2">
              </el-pagination>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="从商品搜索" name="third">
            <el-row>
              <el-table
                  v-loading="skuListLoading3"
                  :data="skuList3"
                  border
                  height="450px"
                  style="width: 100%"
              >
                <el-table-column
                    label="选择" align="center">
                  <template slot-scope="{row}">
                    <el-radio v-model="skuSelected" :label="row.skuId"><span v-text=" "></span>
                    </el-radio>
                  </template>
                </el-table-column>
                <el-table-column label="商品图片" align="center">
                  <template slot-scope="props">
                    <el-image
                        class="img_box_mini"
                        :src="props.row.image"
                        :preview-src-list="[props.row.image]"
                    ></el-image>
                  </template>
                </el-table-column>
                <el-table-column label="商品名称" prop="productName" align="center">
                </el-table-column>
                <el-table-column label="规格" prop="specs" align="center">
                </el-table-column>
                <el-table-column label="货号" prop="snCode" align="center">
                </el-table-column>
                <el-table-column label="商家名称" prop="shopName" align="center">
                </el-table-column>
              </el-table>
            </el-row>
            <el-row>
              <el-pagination
                  :current-page.sync="dialog_page3"
                  :page-size="dialog_size3"
                  layout="total, prev, pager, next"
                  :total="dialog_total3">
              </el-pagination>
            </el-row>
          </el-tab-pane>
        </el-tabs>


      </el-dialog>

      <el-dialog
          title="是否配货正确？"
          :visible.sync="confirmDialog"
          width="50%">
        <el-image style="height: 220px; width: 200px" :src="productConfirm.productPic"
                  :preview-src-list="[productConfirm.productPic]">
        </el-image>
        <div style="font-size: 16px; font-weight: bold;">商品名称：{{ productConfirm.productName }}</div>
        <div style="font-size: 16px; font-weight: bold;">商家编码：{{ productConfirm.code }}</div>
        <div style="font-size: 16px; font-weight: bold;">规格：{{ productConfirm.specs }}</div>
        <span slot="footer" class="dialog-footer">
        <el-button @click="cancelProductConfirm">取 消</el-button>
        <el-button type="primary" @click="productConfirmForBatch">确 认</el-button>
      </span>
      </el-dialog>

      <el-drawer
          title="播种框信息"
          :visible.sync="sowingCellOrdersDrawer"
          direction="ltr"
          size="80%"
      >
        <div style="display: flex;">
          <div style="flex: 1;">
            <div>
              已配商品
            </div>
            <el-table
                v-loading="sowingCellOrdersLoading"
                :data="sowingCellDispatchedOrders"
                border
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                style="width: 96%; margin-left: 20px; margin-top: 10px"
                size="mini"
            >
              <el-table-column align="center" label="商品图片">
                <template slot-scope="{ row }">
                  <el-image
                      class="img_box_mini"
                      :src="row.product_pic"
                      :preview-src-list="[row.product_pic]"
                  >
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column align="center" label="商品名称" prop="product_name">
              </el-table-column>
              <el-table-column align="center" label="货号" prop="code">
              </el-table-column>
              <el-table-column align="center" label="规格" prop="specs">
              </el-table-column>
              <el-table-column align="center" label="数量" prop="combo_num">
              </el-table-column>
            </el-table>
          </div>
          <div style="flex: 1;">
            <div>
              应配商品
            </div>
            <el-table
                v-loading="sowingCellOrdersLoading"
                :data="sowingCellOrders"
                border
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                style="width: 96%; margin-left: 20px; margin-top: 10px"
                size="mini"
            >
              <el-table-column align="center" label="商品图片">
                <template slot-scope="{ row }">
                  <el-image
                      class="img_box_mini"
                      :src="row.product_pic"
                      :preview-src-list="[row.product_pic]"
                  >
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column align="center" label="商品名称" prop="product_name">
              </el-table-column>
              <el-table-column align="center" label="货号" prop="code">
              </el-table-column>
              <el-table-column align="center" label="规格" prop="specs">
              </el-table-column>
              <el-table-column align="center" label="数量" prop="combo_num">
              </el-table-column>
            </el-table>
          </div>
        </div>

      </el-drawer>

      <el-dialog title="批次换快递结果" :visible.sync="multiChangeableDialog">
        <el-table :data="multiChangeableList" border>
          <el-table-column property="title" label="" align="center"></el-table-column>
          <el-table-column property="stAdvised" label="换申通" align="center"></el-table-column>
          <el-table-column property="ytAdvised" label="换圆通" align="center"></el-table-column>
          <el-table-column property="ztAdvised" label="换中通" align="center"></el-table-column>
          <el-table-column property="sfAdvised" label="换顺丰" align="center"></el-table-column>
          <el-table-column property="jdAdvised" label="换京东" align="center"></el-table-column>
        </el-table>
      </el-dialog>

      <el-image v-show="false"
                ref="imgRef"
                :preview-src-list="morePicDialog.productImages"></el-image>
    </div>
    <div v-if="newSys">
      <new-sys-page
          :from-logistics-id="logisticsId"
          :from-team-id="teamId || null"
          :from-work-mode="workMode"
          :login-info="userInfo"
          :from-view="view"
          :from-vips="vips"
          :from-qr-text="qrText"
          :from-origin-waybill="originWaybillId"
          :from-printer-code="printerCode"
          :from-auto-waybill="enableGlobalScanListener"
          :waybill-font-size="waybillFontSize"
          @loginChange="handleLoginChange"
          @switchToOldSysFromTeamChange="switchToOldSysFromTeamChange"
          @waybillPopoverQueueUpdate="waybillPopoverQueueUpdate"
          @showWaybillPopover="() => this.displayWaybillsByPopoverManager()"
      ></new-sys-page>
    </div>
  </div>
</template>

<script>
import printer from "~/utils/printer";
import warehouseApi from "~/request/warehouseApi";
import cloudprint from "~/service/cloudprint";
import userApi from "~/request/userApi";
import packagedApi from "~/request/packagedApi";

import afterSaleApi from "~/request/afterSaleApi";
import davinci_printer from "~/utils/davinci_printer";
import remnantApi from "~/request/remnantApi";
import request from "~/request/request";
import platformApi from "~/request/platformApi";
import timeUtil from "~/utils/timeUtil";
import local_printer from "~/utils/local_printer";
import uuid from "~/utils/uuid";
import ks_printer from "~/utils/ksPrinter";
import pddPrinter from "~/utils/pddPrinter";
import sowingApi from "~/request/sowingApi";
import testApi from "~/request/testApi";
import platformUtils from "~/utils/platformUtils";
import slsApi from "~/request/slsApi";
import logisticsUtils from '~/utils/logisticsUtils'
import printerCodeUtils from "~/utils/printerCodeUtils";
import erpProductApi from "~/request/newSys/erpProductApi";
import orderApi from "~/request/orderApi";
import debounce from "~/utils/debounce";
import printerNotifier from "~/utils/printerNotifier";
import channelPrinter from "~/utils/channelPrinter";
import productApi from "~/request/productApi";
import utils from '~/utils'
import xhsPrinter from "~/utils/xhsPrinter";
import MonitorApi from "~/request/monitorApi";
import UserTokenUtils from "~/utils/userTokenUtils";
import errorUtils from "~/utils/errorUtils";
import {createScannerHandler} from "~/utils/scannerUtils";
import exchangeUnusualFlow from "~/utils/exchangeUnusualFlow";

// import GlobalOrderQuery from "~/components/GlobalOrderQuery.vue";

let texts = [];
let cnter = 0
export default {
  // components: {GlobalOrderQuery},
  mixins: [exchangeUnusualFlow],
  data() {
    return {
      deviceOptions: [],
      deviceMonitorView: {
        cacheId: 0,
        id: '',
        key: 'deviceMonitorId',
        loadCache: () => {
          try {
            const id = JSON.parse(localStorage.getItem(this.deviceMonitorView.key))
            if (id) {
              this.$set(this.deviceMonitorView, 'cacheId', id)
            }
          } catch (e) {
          }
        },
        removeCache: () => {
          localStorage.removeItem(this.deviceMonitorView.key)
        },
        cacheDevice: (id) => {
          localStorage.setItem(this.deviceMonitorView.key, id)
        },
        loadList: () => {
          const loading = utils.getGlobalLoading({
            text: '设备加载中...'
          })
          MonitorApi.findDeviceMonitorRelationListByPage({
            page: 0,
            size: 100,
            relationDto: {}
          }).then(pageResult => {
            this.deviceOptions = pageResult.data
            // 初始化
            const {cacheId = 0} = this.deviceMonitorView
            // 缓存的设备关系是否还存在
            const exist = this.deviceOptions.some(device => device.id === cacheId)
            if (!exist) {
              // 不存在则删除缓存并重置id
              this.deviceMonitorView.removeCache()
              this.$set(this.deviceMonitorView, 'id', '')
            } else {
              this.$set(this.deviceMonitorView, 'id', cacheId)
            }
          }).catch(err => {
            this.$message.error(err.message)
          }).finally(() => {
            loading.close()
          })
        },
        deviceChange: (val) => {
          this.$set(this.deviceMonitorView, 'id', val)
          this.deviceMonitorView.cacheDevice(val)
        }
      },

      lastScanTimer: null,
      matchChannel: '',
      matchChannels: [
        // {label: '未选择', value: ''},
        {label: '托管-配单', value: '2'},
        {label: '到货-配单', value: '0'},
        {label: '售后-配单', value: '3'}
      ],

      // 多件默认托管配单
      matchChannel2: '2',

      newSys: false,
      debugMode: false,

      teamForIntercept: null,

      DEFAULT_PRINTER: "",
      fakeEnter: false,
      lastGap: 0,
      continuousCount: 0,

      productConfirm: {},
      confirmDialog: false,
      labelPrinter: null,
      barCode: '',
      realBarCode: '',
      keyUpLastTime: undefined,
      lastKey: '',

      skuListLoading3: false,
      dialog_page3: 1,
      skuList3: [],
      dialog_size3: 200,
      dialog_total3: 0,
      selectedRow: null,
      //dynamicPic: '',
      update_sku_platform: 0,
      realTeamId: null,

      afterSaleOrder: {},
      originWaybillId: '',
      realSku: '',
      //链接选择相关
      activeTab: 'first',
      dialog_total: 0,
      dialog_total2: 0,
      dialog_page: 0,
      dialog_page2: 0,
      dialog_size: 20,
      dialog_size2: 200,
      keyword: '',
      skuSelected: '',
      skuListLoading: false,
      skuListLoading2: false,
      skuListDialogVisible: false,
      skuList1: [],
      skuList2: [],

      popVisible: false,
      scanWaybillId: "",
      productDialogVisible: false,
      productItem: {},

      waybillSelections: [],
      qrContent: '',

      LOGISTICS_INFO: "logistics",
      unusuals: [
        {
          name: '换货',
          code: 8,
        },
        {
          name: "无头件",
          code: 1,
        },
        {
          name: "多件",
          code: 2,
        },
        {
          name: "少件",
          code: 3,
        },
        {
          name: "错件",
          code: 4,
        },
        {
          name: "影响二次销售",
          code: 5,
        },
        {
          name: "换单拦截",
          code: 6,
        },
        {
          name: '售后关闭',
          code: 7,
        }

      ],
      printerCodes: [],
      unusual: null,
      workModes: [
        {
          name: "拆包处理",
          code: 0,
        },
        {
          name: "拦截件",
          code: 1,
        },
        {
          name: "样衣",
          code: 2,
        },
        {
          name: "售后查询",
          code: 3
        }
      ],
      workMode: 0,
      printerCode: null,
      platform: 0,
      upType: null,
      allUser: false,
      timeRange: [],
      taskGroups: [],
      taskGroup: {id: 0, title: "未分配"},
      teamId: "",
      qrText: "",
      realQrText: "",

      printConnect: "danger",
      davinciPrintConnect: "danger",
      ksPrinterConnect: 'danger',
      pddPrinterConnect: 'danger',
      channelPrinterConnect: 'danger',
      xhsPrinterConnect: 'danger',

      serverConnect: "danger",
      loginConnect: "danger",
      ytLogistics: "danger",
      ztLogistics: "danger",
      ydLogistics: "danger",
      logisticsId: 7,
      printDataList: [],
      qrTextQueue: [],
      //printDataMap: new Map(),
      printers: [],
      printerName: "",
      view: 1,
      multipleOrders: [],
      records: [],
      userInfo: {
        userId: 0,
        name: "未登录",
      },
      // 0 预分配完成  1 1单多件待处理 2 处理发货中
      // 3 同步时退款  4 手动操作取消 5 长时间未处理自动取消 6 异常取消
      // 9 其他
      // 10 同步物流成功 11 同步物流异常
      statusMap: {
        0: "待发货",
        2: "系统处理中",
        3: "非备货中",
        4: "操作取消",
        5: "未处理取消",
        6: "异常取消",
        10: "同步成功",
        11: "同步发生异常",
      },
      vips: [],
      vipName: "",
      skuList: [],
      taskGroupCreateViewable: false,
      taskSku: [],
      qrCode: "",
      afterList: [],

      qrSelected: '',
      filterSelected: 3,
      changeWaybillId: '',
      qrTextInfo: '',

      LOGISTICS_COMPANIES: [],
      outerPopVisible: false,
      outerPopoverMsg: '',
      waybillFontSize: 180, // 快递单号弹窗字体大小，范围 60-180

      packageWaybillMode: 0,
      packageWaybill: '',
      packageWaybillList: [],

      dates: [],
      pickerOptions2: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一月',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)

              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三月',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)

              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      expressDeliveryList: [],
      pageInfo: {
        page: 0,
        size: 30,
        total: 0
      },
      courierInfo: {},
      courierInfoB: {},
      expressDeliveryLoading: false,

      // sowingWall: '',
      showScanSowingWall: false,
      sowingWallQrText: '',
      sowingWall: {},
      columns: [],
      multipleQrText: '',
      multipleSearchQrText: '',
      multiGroupQrText: '',

      sowingDeliveryScanDialog: false,
      sowingProductQrTexts: [],
      sowingProductQrText: '',
      sowingCell: {},

      sowingCellOrdersDrawer: false,
      sowingCellOrdersLoading: false,
      sowingCellOrders: [],
      sowingCellDispatchedOrders: [],

      PLATFORMS: [],
      courierUserSelected: 1,

      multiSendResult: new Map(),
      multiChangeableList: [],
      multiChangeableDialog: false,
      multiPageSize: 10,

      popoverManager: {
        displaying: false,
        queue: [],
        waybillId: '',
        duration: 2000,
        interval: 2400,
        working: false,
        enabled: true
      },
      sowingData: {
        loading: false,
        data: [],
        selections: []
      },
      sowingQuery: {
        page: 0,
        size: 20,
        total: 0,
        timeType: 2
      },

      morePicDialog: {
        productImages: [],
        showImages: (images) => {
          this.$set(this.morePicDialog, 'productImages', images)
          this.$refs.imgRef.showViewer = true
        }
      },

      selections: [],

      boxSendView: {
        box: false,
        BOX_SEND_KEY: 'BOX_SEND',

        init: () => {
          try {
            const boxSend = JSON.parse(localStorage.getItem(this.boxSendView.BOX_SEND_KEY))
            this.$set(this.boxSendView, 'box', boxSend)
          } catch (e) {

          }
        },

        switchBoxSend: () => {
          const superior = this.superior
          if (!superior) {
            this.$message.warning('您无权限切换是否盒子发货，请联系仓管')
            return
          }
          const target = !this.boxSendView.box
          const targetDesc = target ? '盒子发货' : '非盒子发货'
          this.$confirm(`确认切换为【${targetDesc}】？`, '提示').then(() => {
            this.$set(this.boxSendView, 'box', target)
            localStorage.setItem(this.boxSendView.BOX_SEND_KEY, JSON.stringify(target))
          })
        },

        getBoxClass() {
          return this.box ? 'box-view-enabled' : 'box-view-disabled'
        },

        notify: () => {
          const box = this.boxSendView.box
          const message = box ? '盒子发货' : '非盒子发货'
          this.$alert(`当前是【${message}】`, '请注意')
        }
      },

      customerBagView: {
        bag: false,
        CUSTOMER_BAG_KEY: 'CUSTOMER_BAG',

        init: () => {
          try {
            const customerBag = JSON.parse(localStorage.getItem(this.customerBagView.CUSTOMER_BAG_KEY))
            this.$set(this.customerBagView, 'bag', customerBag || false)
          } catch (e) {

          }
        },

        handleSwitchChange: (value) => {
          const superior = this.superior
          if (!superior) {
            this.$message.warning('您无权限切换客户打包物料设置，请联系仓管')
            // 恢复开关状态
            this.$nextTick(() => {
              this.$set(this.customerBagView, 'bag', !value)
            })
            return
          }

          const targetDesc = value ? '客户打包物料' : '非客户打包物料'
          this.$confirm(`确认切换为【${targetDesc}】？`, '提示').then(() => {
            localStorage.setItem(this.customerBagView.CUSTOMER_BAG_KEY, JSON.stringify(value))
            this.$message.success(`已切换为【${targetDesc}】`)
          }).catch(() => {
            // 用户取消，恢复开关状态
            this.$nextTick(() => {
              this.$set(this.customerBagView, 'bag', !value)
            })
          })
        },

        notify: () => {
          const bag = this.customerBagView.bag
          const message = bag ? '客户打包物料' : '非客户打包物料'
          this.$alert(`当前是【${message}】`, '请注意')
        }
      },

      currentRequestID: null,

      randomScanView: {
        qrText: '',
        teamId: 5164022,
        onInput: (value) => {
          this.$set(this.randomScanView, 'qrText', value + "")
        },
        onScan: () => {
          let printerName = this.printerName
          if (!printerName) {
            this.$message.error('请选择打印机')
            return
          }
          const {qrText, teamId} = this.randomScanView
          const logisticsId = this.logisticsId
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          })
          warehouseApi.scanAndSendRandomly({qrText, logisticsId, teamId}).then(printData => {
            if (printData.status === 0) {
              this.popoverManager.queue.push(printData.waybillId)
              this.$set(this.randomScanView, 'qrText', '')
              cloudprint.doPrint(printData, printerName, false).then(() => {
              }).catch(err => {
                this.$alert(JSON.stringify(err), '出单失败')
              })
            } else {
              this.$alert(printData.errorMsg, '发货失败')
            }
            loading.close()
          }).catch(error => {
            this.$alert(error.message, '发货接口调用失败')
            loading.close()
          })
        }
      },

      enableGlobalScanListener: false, // 手动开启是否全局监听物流输入
      globalScanner: null,
      waybillScanner: null
    };
  },
  computed: {
    waybillPopoverWidth() {
      // 根据字体大小计算弹窗宽度：60px字体对应50%宽度，180px字体对应95%宽度
      const minFontSize = 60;
      const maxFontSize = 180;
      const minWidth = 50;
      const maxWidth = 95;
      const ratio = (this.waybillFontSize - minFontSize) / (maxFontSize - minFontSize);
      const width = minWidth + ratio * (maxWidth - minWidth);
      return `${width}%`;
    },
    recordsNum() {
      if (this.records == null) {
        return 0;
      }
      let num = 0;
      for (let r of this.records) {
        num += r.num || 1;
      }
      return num;
    },
    superior() {
      return (
          this.userInfo.roles != null &&
          (this.userInfo.roles.includes("WarehouseSuperior") || this.userInfo.roles.includes("SelfSuperior"))
      );
    },
    queueIndex() {
      let index = -1
      let bId = this.qrSelected
      let queue = this.qrTextQueue
      if (bId !== null) {
        index = queue.findIndex(item => item.batchId === bId)
      }
      return index
    },
    qrContentInput(value) {
      console.log(value)
      this.qrContent = value + ''
    },
    scanTextResult() {
      let index = this.queueIndex
      if (index > -1) {
        let stAdvised = 0
        let ytAdvised = 0
        let ztAdvised = 0
        let sfAdvised = 0
        let jdAdvised = 0

        let total = 0
        let printMiss = 0
        let success = 0
        let fail = 0
        let retry = 0
        let printData = this.qrTextQueue[index].printDataList
        printData.forEach(item => {
          if (item.nextStatus === 1) {
            retry++
          }
          if (item.status === 0) {
            if ((item.printStatus && item.printStatus.status !== 'success') || !item.printStatus) {
              printMiss++
            }
            success++
            total++
          } else {
            fail += item.errNum || 1
            total += item.errNum || 1
          }
          // 可换快递
          if (item.status === 12 && item.errorMsg) {
            const {errorMsg} = item
            if (errorMsg.indexOf('请用申通') > -1) {
              stAdvised++
            } else if (errorMsg.indexOf('请用圆通') > -1) {
              ytAdvised++
            } else if (errorMsg.indexOf('请用中通') > -1) {
              ztAdvised++
            } else if (errorMsg.indexOf('请用顺丰') > -1) {
              sfAdvised++
            } else if (errorMsg.indexOf('请用京东') > -1) {
              jdAdvised++
            }
          }
        })
        return {
          success,
          fail,
          total,
          retry,
          stAdvised,
          ytAdvised,
          ztAdvised,
          sfAdvised,
          jdAdvised,
          printMiss
        }
      } else {
        return {
          success: 0,
          fail: 0,
          total: 0,
          retry: 0,
          stAdvised: 0,
          ytAdvised: 0,
          ztAdvised: 0,
          sfAdvised: 0,
          jdAdvised: 0,
          printMiss: 0
        }
      }
    },
    filterPrintData() {
      let index = this.queueIndex
      if (index > -1) {
        let printData = this.qrTextQueue[index].printDataList
        let filterSelected = this.filterSelected
        if (filterSelected === 1) {
          printData = printData.filter(item => item.status === 0)
        } else if (filterSelected === 2) {
          printData = printData.filter(item => item.status !== 0)
        } else if (filterSelected === 4) {
          printData = printData.filter(item => item.nextStatus === 1)
        } else if (filterSelected === 5) {
          printData = printData.filter(item => {
            return item.status === 0 && ((item.printStatus && item.printStatus.status !== 'success') || !item.printStatus)
          })
        }
        return printData
      } else {
        return []
      }
    },
    productInfo() {
      const index = this.queueIndex
      if (index > -1) {
        let printData = this.qrTextQueue[index].printDataList
        if (printData && printData.length > 0) {
          for (let i = 0; i < printData.length; i++) {
            if (printData[i].productPic)
              return {
                productPic: printData[i].productPic,
                productName: printData[i].productName,
                specs: printData[i].specs,
                code: printData[i].code
              }
          }
        }
        return {}
      } else {
        return {}
      }
    },

  },
  mounted() {
    this.deviceMonitorView.loadCache()
    this.boxSendView.init()
    this.customerBagView.init()
    this.printerCodes = printerCodeUtils.getPrinterCodes()
    this.PLATFORMS = platformUtils.getOptions(false, true, true)
    this.LOGISTICS_COMPANIES = logisticsUtils.getCompanyOptions()
    let logistics = localStorage.getItem(this.LOGISTICS_INFO);
    if (logistics) {
      this.logisticsId = logistics * 1;
    } else {
      //默认 物流
      this.logisticsId = logisticsUtils.getDefaultLogistics();
      localStorage.setItem(this.LOGISTICS_INFO, this.logisticsId + "");
    }
    //初始化页面时暂不弹出快递信息
    //this.showCurrentLogistics()
    const debugMode = this.debugMode
    if (debugMode) {
      userApi.userIdLogin(UserTokenUtils.genLoginToken(816186318 + '')).then(userInfo => {
        this.userInfo = userInfo
        request.setSessionKey(userInfo.sessionKey)
        this.loadPrinters()
        this.loadVips()
        this.showCurrentLogistics()
        this.loginConnect = "success"
        this.qrText = ""

        // 默认查询条件
        // this.vipName = 26
        // this.printerCode = '20220106'
        // this.view = 1
        // this.newSys = true
      }).catch(err => {
        console.log("userIdLogin err", err)
        this.$message.error(err.message)
      })
    } else {
      this.loadAndSaveCourier()
    }


    this.ytLogistics = this.logisticsId === 7 ? "success" : "danger";
    this.ztLogistics = this.logisticsId === 15 ? "success" : "danger";
    this.ydLogistics = this.logisticsId === 9 ? "success" : "danger";
    const _this = this
    setTimeout(() => {
      _this.getPrinters()
    }, 3000)

    window.onbeforeunload = function (event) {
      event.returnValue = "确认离开？"
      console.log("event", event)
    };

    this.globalScanner = this.getGlobalScannerHandler()

    // 初始检查，如果初始 view === 6，则添加监听
    this.updateScannerListeners();

  },
  methods: {
    getGlobalScannerHandler() {
      return createScannerHandler({
        onComplete: qrText => {
          this.vipName = ''
          this.teamId = ''
          this.qrText = qrText
          this.waybillScan(this.event, null, true)
        },
        minLength: 7,
        maxInterval: 100
      })
    },

    // showGlobalQuery() {
    //   // 检查登录与否
    //   const userInfo = this.userInfo
    //   if (userInfo && userInfo.userId) {
    //     this.$refs.globalOrderQuery.show()
    //   } else {
    //     this.$message.error('请先登录！')
    //   }
    // },

    onAfterSaleProcessComplete() {
      // 清空输入框
      this.qrText = ''
      // 聚焦输入框
      this.$refs.waybillInputRef.focus()
    },

    getMessage(message) {
      return message.replace('盒子发货', `<span style="color: #67C23A; font-weight: bolder;">盒子发货</span>`)
    },

    toLoadMorePictures(item) {
      const {pid} = item.productVo
      const {shopId, platform, productImages} = item
      if (productImages) {
        this.morePicDialog.showImages(productImages)
        return
      }

      // console.log('@@@ddd', pid, shopId, platform)
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      productApi.productDetailForVariousPlatforms({
        productId: pid,
        shopId,
        platform
      }).then(data => {
        // console.log('@productDetail@@', data)
        const {lbImages, xqImages} = data
        item.productImages = [...lbImages, ...xqImages].map(img => img.url)
        this.morePicDialog.showImages(item.productImages)
      }).catch(err => {
        console.error(err.message)
        this.$message.error(err.message)
      }).finally(() => {
        loading.close()
      })
    },

    getItemProductName(productName) {
      productName = productName || ''
      const pattern = /\w*\d{3,}/g
      const matches = productName.match(pattern)
      if (matches && matches.length) {
        matches.forEach(mc => {
          productName = productName.replace(mc, `<span style="color: red; font-weight: bold; font-size: xx-large;">${mc}</span>`)
        })
      }
      // console.log('prodName', productName)
      return productName
    },

    getItemOrderVoView(child) {
      const orderVo = child.orderVo || {}
      const confirmPlatforms = [0, 1, 7, 16, 17]
      const refundAmount = child.refundAmount || child.refundFee
      return {
        visible: confirmPlatforms.includes(child.platform),
        payAmount: orderVo.payAmount / 100 || '-',
        refundAmount: refundAmount / 100 || '-'
      }
    },

    reprintable(row, index) {
      const {printData, waybillId} = row
      return printData && waybillId
    },

    reprintWaybills() {
      const selections = this.selections
      if (!selections.length) {
        this.$message.warning('请勾选需要重打的项目')
        return
      }
      let printerName = this.printerName
      this.$confirm('确认批量重打？', '提示').then(() => {
        this.doBatchReprintPromise(0, selections, printerName).then(() => {
          this.$message.success('已重打')
        })
      }).catch(() => {
        this.$message.info('已取消')
      })

    },

    clearPrintResultResult() {
      cloudprint.resetCloudPrinter()
      this.$message.success('清除成功！')
    },

    batchSowingReprintBySelections() {
      const {selections} = this.sowingData
      if (!selections || !selections.length) {
        this.$message.warning('请勾选需要重打的记录')
        return
      }
      this.$confirm('确认重打?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        selections.forEach(row => {
          this.reprintWaybill(row.waybillId)
        })
      }).catch(() => {

      })
    },

    getVipByTeamId(teamId) {
      return this.vips.find(v => v.teamId === teamId * 1)
    },

    waybillInterceptPreQueryPromise(waybill, selectedTeam) {
      // 返回值的说明：
      // 0 直接继续查询，1 切换团队系统不切换 2 切换团队 切换系统
      return new Promise((resolve, reject) => {
        afterSaleApi.findSourceByInterceptWaybill(waybill).then(source => {
          const {teamId, version} = source
          if (teamId !== selectedTeam) {
            this.vipName = teamId
            this.changeVip(this.vipName)
            const result = ((!!version) === this.newSys) ? 1 : 2
            resolve(result)
          } else {
            resolve(0)
          }
        }).catch(err => {
          if (selectedTeam) {
            resolve(0)
          } else {
            reject(err)
          }
        })
      })
    },

    sowingReprint(row) {
      this.$confirm('确认重打?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.reprintWaybill(row.waybillId)
      }).catch()
    },

    loadSowingRecords(page) {
      const query = this.sowingQuery
      const {dates, timeType, hasPrinted, packer, size, deliveryStatus} = query
      let finalDates = dates
      if (!dates || !dates.length) {
        const start = new Date()
        start.setTime(start.getTime() - 1000 * 60 * 60 * 24)
        const end = new Date()
        finalDates = [timeUtil.format(start, 'yyyy-MM-dd hh:mm:ss'), timeUtil.format(end, 'yyyy-MM-dd hh:mm:ss')]
      }
      const endTimeAttr = timeType === 2 ? 'logisticsTime' : 'lastUpdateTime'
      const finalQuery = {
        createdTime: finalDates[0],
        [endTimeAttr]: finalDates[1],
        actionStatusList: [6, 7, 8, 10, 11, 12],
        hasPrinted,
        packer
      }
      if (deliveryStatus) {
        try {
          finalQuery.actionStatusList = JSON.parse(deliveryStatus)
        } catch (ignored) {

        }
      }
      this.$set(this.sowingData, 'loading', true)
      warehouseApi.preMatchedOrderList({
        page: page || 0,
        size: size || 50,
        isSowingModel: 'true'
      }, finalQuery).then(data => {
        this.$set(this.sowingData, 'data', data.data)
        this.$set(this.sowingQuery, 'total', data.total)
        this.$set(this.sowingQuery, 'page', data.page)
        data.data.forEach(item => {
          this.loadProductInfoFromPre(item)
        })
      }).catch(error => {
        this.$message.error(error.message)
      }).finally(() => {
        this.$set(this.sowingData, 'loading', false)
      })
    },

    loadProductInfoFromPre(item) {
      this.$set(item, 'productLoading', true)
      const children = item.children
      const orders = []
      if (children && children.length) {
        // 如果是一单多件
        const ords = children.map(child => {
          return {
            orderId: child.orderId,
            platform: child.platform,
            multiple: true
          }
        })
        orders.push(...ords)
      } else {
        // 如果不是，直接拿订单号 和 平台信息
        const {orderId, platform} = item
        orders.push({
          orderId,
          platform,
          multiple: false
        })
      }
      // console.log('orders', orders)
      const promises = []
      const nullProduct = {
        productName: '找不到订单信息'
      }
      orders.forEach(o => {
        const query = {
          idList: [o.orderId]
        }
        const promise = new Promise(resolve => {
          orderApi.findOrders(query, 0, 50, 2, o.platform, 2).then(data => {
            const resList = data.data
            if (resList && resList.length) {
              const children = resList[0].children
              const index = children.findIndex(child => child.order_id === o.orderId)
              if (index > -1) {
                const child = children[index]
                const comboNum = o.multiple ? 1 : child.combo_num
                const product = {
                  image: child.product_pic,
                  productName: child.product_name,
                  snCode: child.code,
                  specs: child.specs,
                  orderId: child.order_id,
                  num: comboNum
                }
                resolve(product)
              }
            }
            resolve(nullProduct)
          }).catch(err => {
            resolve(nullProduct)
          })
        })
        promises.push(promise)
      })

      Promise.all(promises).then(resultList => {
        // preMatchedOrderChild一单多件可能存在同款
        // 对同样的orderId的结果进行合并
        const orderMap = new Map()
        resultList.forEach(res => {
          const {orderId} = res
          if (orderId) {
            if (orderMap.has(orderId)) {
              let product = orderMap.get(orderId)
              const {num} = res
              product.num = product.num + num
              orderMap.set(orderId, product)
            } else {
              orderMap.set(orderId, res)
            }
          }
        })
        const productList = [...orderMap.values()]
        this.$set(item, 'product', productList)
        this.$set(item, 'productLoading', false)
      })
    },

    async batchSowingDelivery() {
      const printerName = this.printerName
      const userId = this.userInfo.userId
      if (!userId) {
        this.$message.warning('请先登录')
        return;
      }
      if (!printerName) {
        this.$message.warning('请先选择打印机！')
        return
      }

      try {
        await this.$confirm(
            '将对播种墙进行批量发货, 是否继续?',
            '提示',
            { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
        )
      } catch (e) {
        return
      }

      try {
        const { id } = this.sowingWall
        const loading = this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
        const list = await sowingApi.findSowingCellByParentAndStatus(id, null, 'true')
        const matchedCellList = list
            .filter(item => item.status === 2)
            .map(item => item.id)
            .sort((a, b) => a - b)
        const groupSize = 3
        const groups = []

        for (let i = 0; i * groupSize < matchedCellList.length; i++) {
          const start = i * groupSize
          const end = Math.min(start + groupSize, matchedCellList.length)
          groups.push(matchedCellList.slice(start, end))
        }

        const results = []
        let chain = Promise.resolve()
        for (const cellIds of groups) {
          chain = chain
              .then(() => this.buildSowingOrderSendPromise(id, this.logisticsId, userId, cellIds))
              .then(res => results.push(res))
        }
        await chain
        loading.close()
        this.loadSowingCells()
        this.loadSowingRecords()

        const finalResult = results.reduce(
            (acc, cur) => ({ success: acc.success + cur.success, fail: acc.fail + cur.fail }),
            { success: 0, fail: 0 }
        )
        const { success, fail } = finalResult
        this.$alert(`成功【${success}】单，失败【${fail}】单`, '获取面单结果')
      } catch (err) {
        this.$message.error(err.message)
      }
    },

    waybillPopoverQueueUpdate(waybillId) {
      this.popoverManager.queue.push(waybillId)
    },

    displayWaybillsByPopoverManager() {
      const manager = this.popoverManager
      const {displaying, working, duration, interval} = manager
      if (!manager.queue || !manager.queue.length) return

      // 如果正在弹框
      if (displaying || working) {
        return
      }
      this.displayWaybillPromise(duration, interval).then(() => {
        this.displayWaybillsByPopoverManager()
      })
    },

    displayWaybillPromise(duration, interval) {
      // 如果当前没有弹框
      return new Promise(resolve => {
        this.$set(this.popoverManager, 'displaying', true)
        this.$set(this.popoverManager, 'working', true)
        const waybill = this.popoverManager.queue.shift()
        this.$set(this.popoverManager, 'waybillId', waybill)
        setTimeout(() => {
          this.$set(this.popoverManager, 'displaying', false)
        }, duration)
        setTimeout(() => {
          this.$set(this.popoverManager, 'working', false)
          resolve()
        }, interval)
      })

    },

    getRequestID() {
      return uuid.getUUID(8, 16)
    },

    switchToOldSysFromTeamChange(memo) {
      this.newSys = false
      const {view, teamId, afterView} = memo
      this.view = view
      this.vipName = teamId
      if (view === 2) {
        // 多件发货模块
        // 直接加载多件发货信息
        this.changeVip(teamId, false)
      } else if (view === 6) {
        // 售后模块
        if (afterView) {
          const {workMode, printerCode, labelPrinter, qrText, originWaybillId} = afterView
          this.workMode = workMode
          this.printerCode = printerCode
          this.labelPrinter = labelPrinter
          if (qrText && workMode === 1) {
            this.qrText = qrText
            this.originWaybillId = originWaybillId || ''
            this.waybillScan()
          }
        }
      }
    },

    getProductInfoFromQrTextPromise(qrText) {
      // 只有条码信息，不能直接知道 是新系统用户还是旧系统用户
      // 策略1：看看能不能拿到条码的团队ID, 匹配我们的vips。如果找得到，就直接确定了是否是新系统用户。无法确定则全查
      // 策略2：直接先查新接口去erpSku表找，找不到就旧接口继续找
      // 这里先使用
      return new Promise((resolve) => {
        erpProductApi.findErpSkuVoByQrText(qrText).then(erpSku => {
          resolve(erpSku)
        }).catch(() => {
          warehouseApi.getSkuInfoForScanQrText(qrText).then(matchedOrderVo => {
            const {product_pic, product_name, specs, code} = matchedOrderVo
            resolve({
              image: product_pic,
              productName: product_name,
              code,
              specs
            })
          }).catch(err => {
            resolve({
              productName: err.message,
              specs: '找不到商品信息',
            })
          })
        })
      })
    },

    handleLoginChange(userInfo) {
      this.userInfo = userInfo
      request.setSessionKey(userInfo.sessionKey)
      this.loadPrinters()
      this.loadVips()
      this.showCurrentLogistics()
      this.loginConnect = "success"
      this.qrText = ""
    },

    changeSys(newSys) {
      return
      const desc = newSys ? '新系统' : '旧系统'
      this.$confirm(`确认切换为【${desc}】`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.newSys = newSys
      }).catch(() => {

      })
    },

    buildMultiOrderSendPromise(ids, logisticsId, userId) {
      return new Promise(resolve => {
        warehouseApi.multipleOrderSend(ids, logisticsId, userId).then(result => {
          // 这里就可以先分别打印了
          let printData = result.data.filter(item => item.status === 0)
          if (printData && printData.length) {
            const waybills = printData.map(item => item.waybillId)
            this.popoverManager.queue.push(...waybills)
            cloudprint.doPrintBath(printData, this.printerName)
                .then(() => {
                })
                .catch((error) => {
                  console.log('doPrintBath error', error)
                  this.$message.error(error.message)
                })
            this.displayWaybillsByPopoverManager()
          }
          resolve(result)
        }).catch(err => {
          this.$message.error(err.message)
          resolve({
            errMsg: err.message,
            errNum: ids.length
          })
        })
      })
    },

    buildSowingOrderSendPromise(parentCellId, logisticsId, userId, cellIds) {
      return warehouseApi
          .batchMultipleOrderSendBySowing({ parentCellId, logisticsId, userId, cellIds })
          .then(printDataList => {
            const successPrintDataList = printDataList.filter(p => p.status === 0)
            if (successPrintDataList.length) {
              const waybills = successPrintDataList.map(item => item.waybillId)
              this.popoverManager.queue.push(...waybills)
              this.displayWaybillsByPopoverManager()
            }

            const success = successPrintDataList.length
            const fail = printDataList.length - success

            if (successPrintDataList.length) {
              return cloudprint
                  .doPrintBath(successPrintDataList, this.printerName)
                  .then(() => ({ success, fail }))
            }

            return { success, fail }
          })
          .catch(err => {
            this.$message.error(err.message)
            return { success: 0, fail: cellIds.length }
          })
    },

    toEditMultiPageSize() {
      const pageSize = this.multiPageSize
      this.$prompt('请输入批次返回的条数', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: pageSize
      }).then(({value}) => {
        value = value * 1
        console.log('newSize', value, isNaN(value))
        if (isNaN(value) || value <= 0) {
          this.$message.warning('请输入合法的数量!')
          return
        }
        this.multiPageSize = value
        // 重新加载批次信息
        this.changeTaskGroup()
      }).catch(() => {
      })
    },

    loadTaskGroupByQrText() {
      let qrText = this.multiGroupQrText || ''
      qrText = qrText.trim()
      if (qrText) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })
        warehouseApi.findAllRemnantReadyOrderGroup(this.teamId, 1, qrText).then((data) => {
          loading.close()
          this.multiGroupQrText = ''
          if (data && data.length) {
            this.taskGroups = data
            // 默认选中第一个批次
            this.taskGroup = data[0]
            this.changeTaskGroup()
          } else {
            // 保留原来的批次列表
            this.$message.warning('找不到符合条件的批次！')
          }
        }).catch(err => {
          loading.close()
          console.log('findAllRemnantReadyOrderGroup err', err)
          this.$message.error('错误提示: ' + err.message)
        })
      }
    },

    transformDeliver(deliver) {
      if (deliver.indexOf('申通') > -1) {
        deliver = deliver.replace('申通', this.elTagGenerator('申通', '#FFE940'))
      }

      if (deliver.indexOf('圆通') > -1) {
        deliver = deliver.replace('圆通', this.elTagGenerator('圆通', 'green'))
      }

      if (deliver.indexOf('中通') > -1) {
        deliver = deliver.replace('中通', this.elTagGenerator('中通', 'blue'))
      }

      if (deliver.indexOf('顺丰') > -1) {
        deliver = deliver.replace('顺丰', this.elTagGenerator('顺丰', 'black'))
      }

      if (deliver.indexOf('京东') > -1) {
        deliver = deliver.replace('京东', this.elTagGenerator('京东', 'red'))
      }
      return deliver
    },

    elTagGenerator(content, type) {
      return `<span style="color: ${type}; font-weight: bold; font-size: 24px;">${content}</span>`
    },

    showMultiSendResult() {
      const map = this.multiSendResult
      const taskGroup = this.taskGroup
      const key = taskGroup.id
      if (map.has(key)) {
        const result = map.get(key)
        const {
          stAdvised,
          ytAdvised,
          ztAdvised,
          sfAdvised,
          jdAdvised,
          totalStAdvised,
          totalYtAdvised,
          totalZtAdvised,
          totalSfAdvised,
          totalJdAdvised
        } = result
        const row1 = {
          title: '上次结果',
          stAdvised,
          ytAdvised,
          ztAdvised,
          sfAdvised,
          jdAdvised
        }
        const row2 = {
          title: '合计',
          stAdvised: totalStAdvised,
          ytAdvised: totalYtAdvised,
          ztAdvised: totalZtAdvised,
          sfAdvised: totalSfAdvised,
          jdAdvised: totalJdAdvised
        }
        this.multiChangeableList = [row1, row2]
        this.multiChangeableDialog = true
      } else {
        this.$message.info('无可换快递信息!')
      }
    },

    refreshPrintResultForRow(row) {
      // console.log('refreshPrintResultForRow', row)
      const index = this.queueIndex
      let queue = this.qrTextQueue
      const batch = queue[index]
      // 只有时分秒，需要处理跨天的情况
      let scanTime = batch.time
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      this.refreshPrintResultPromise(row, scanTime).then(res => {
        if (res.row && res.result && res.result.length) {
          const task = res.result[0]
          const {printStatus} = task
          const docList = printStatus.filter(status => status.documentID === row.waybillId)
          if (docList && docList.length) {
            this.$set(row, 'printStatus', docList[0])
          }
        }
        this.$message.success('刷新成功!')
        loading.close()
      }).catch(err => {
        this.$message.error('刷新失败：' + err.message)
        loading.close()
      })

    },

    refreshPrintResultForBatch() {
      const index = this.queueIndex
      if (index === -1) {
        this.$message.warning('暂时没有获取面单的记录!')
        return
      }
      let queue = this.qrTextQueue
      const printDataList = queue[index].printDataList
      // console.log('refreshPrintResultForBatch list', printDataList)
      const batch = queue[index]
      let scanTime = batch.time
      // 找到所有查询超时的物流单对应的row
      const unusualRows = printDataList.filter(printData => {
        return printData.printStatus && printData.printStatus.status !== 'success'
      })
      if (!unusualRows || !unusualRows.length) {
        this.$message.warning('没有出单异常的面单!')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      const promises = []
      unusualRows.forEach(row => {
        const promise = this.refreshPrintResultPromise(row, scanTime)
        promises.push(promise)
      })
      Promise.all(promises).then(resultList => {
        resultList.forEach(res => {
          if (res.row && res.result && res.result.length) {
            const row = res.row
            const task = res.result[0]
            const {printStatus} = task
            const docList = printStatus.filter(status => status.documentID === row.waybillId)
            if (docList && docList.length) {
              this.$set(row, 'printStatus', docList[0])
            }
          }
        })
        this.$message.success('刷新成功！')
        loading.close()
      }).catch(err => {
        this.$message.error('错误提示：' + err.message)
        loading.close()
      })
    },

    refreshPrintResultPromise(row, scanTime) {
      // scanTime 只有时分秒，需要处理跨天的情况
      return new Promise((resolve) => {
        const splits = scanTime.split(':')
        const now = new Date()
        const startTime = new Date()
        startTime.setHours(splits[0] * 1)
        startTime.setMinutes(splits[1] * 1)
        startTime.setSeconds(splits[2] * 1)
        if (startTime.getTime() > now.getTime()) {
          startTime.setTime(startTime.getTime() - 1000 * 60 * 60 * 24)
        }
        console.log('startTime', startTime)
        const start = timeUtil.format(startTime, 'yyyy-MM-dd hh:mm:ss')
        const end = timeUtil.format(now, 'yyyy-MM-dd hh:mm:ss')
        const {waybillId} = row
        slsApi.findPrinterResultList(start, end, waybillId).then(res => {
          resolve({result: res, row})
        }).catch(err => {
          resolve({})
        })
      })
    },

    exportCourierScanRecords() {
      const dates = this.dates
      const courierUserSelected = this.courierUserSelected
      if (!dates || dates.length !== 2) {
        this.$message.warning('请选择导出时间范围')
        return
      }
      const query = {
        courierScan: courierUserSelected,
        dateType: 0,
        startTime: dates[0],
        endTime: dates[1],
        warehouseIdList: [1]
      }
      const queryJson = JSON.stringify(query)
      const sessionKey = this.courierInfo.sessionKey
      let url = `/api/yifahuo/afterSale/exportExpressDelivery?queryJson=${queryJson}&sessionKey=${sessionKey}`

      window.open(url, '_blank')
    },

    handleCourierChange(val) {
      this.packageWaybillList = []
    },

    updatePrintResultForPrintDataList(printDataList) {
      printDataList.forEach(printData => {
        const {waybillId} = printData
        if (waybillId) {
          printerNotifier.addListener(waybillId, 'PRINT_RESULT', printStatus => {
            this.$set(printData, 'printStatus', printStatus)
          })
        }
      })
    },

    scanQrText2() {
      // this.$message.success(this.qrText)
      console.log("qrText", this.qrText)
      testApi.scanTextTest().then(res => {
        console.log("scanTextTest res", res)
        this.$message.success('成功!')
      }).catch(err => {
        console.log("scanTextTest err", err)
        this.$message.error(err.message)
      })
    },

    showOrdersInCell(cell) {
      this.sowingCellOrdersDrawer = true
      this.sowingCellOrdersLoading = true
      this.sowingCellOrders = []
      warehouseApi.findOrdersInSowingCell(cell.id).then(data => {
        this.sowingCellOrders = data.totalOrders
        this.sowingCellDispatchedOrders = data.dispatchedOrders
        this.sowingCellOrdersLoading = false
      }).catch(err => {
        this.sowingCellOrdersLoading = false
        this.$message.error(err.message)
      })
    },

    isSowingCellQrCode(text) {
      // let splits = text.split('-')
      // if (splits.length === 4) {
      //   return true
      // } else {
      //   splits = text.split('#');
      //   return splits.length === 4
      // }
      // 播种框二维码变了: 播种墙-编号
      const pattern = /^[^-]+-\d$/
      // console.log('isSowingCellQrCode', text, pattern.test(text))
      return pattern.test(text)
    },

    multipleOrderSendBySowing() {
      const sowingProductQrTexts = this.sowingProductQrTexts
      if (!sowingProductQrTexts || !sowingProductQrTexts.length) {
        this.$message.warning('请扫播种框内的所有商品条码！')
        return
      }
      const qrCodes = sowingProductQrTexts.map(item => item.qrText.trim())
      const sowingCell = this.sowingCell
      const {id, qrCode} = sowingCell
      const logisticsId = this.logisticsId
      let userId = this.userInfo.userId
      const {teamId} = this.sowingWall
      if (!userId) {
        this.$message.error("请先登录");
        return false
      }
      if (!this.printerName) {
        this.$message.warning('请先选择打印机')
        return false
      }

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      warehouseApi.multipleOrderSendBySowing(id, logisticsId, userId, qrCodes, teamId).then(result => {
        loading.close()
        if (result.status === 0) {
          const {waybillId} = result
          this.popoverManager.queue.push(waybillId)
          this.$alert(`【${qrCode}】播种框获取面单成功`, "获取成功", {
            confirmButtonText: "确认",
            callback: () => {
              this.sowingDeliveryScanDialog = false
              this.$refs.multipleQrTextScanner.focus()
              this.loadSowingCells()
            }
          })
          cloudprint.doPrint(result, this.printerName).then(() => {
            this.$message.success("获取面单成功")
          }).catch(err => {
            this.$alert(err.message, "打印错误", {
              confirmButtonText: "去解决",
            })
          })
          this.displayWaybillsByPopoverManager()
        } else {
          this.$alert(
              `【${qrCode}】播种框获取面单失败：${result.errorMsg}`,
              "订单异常",
              {
                confirmButtonText: "确认",
                callback: () => {
                  this.loadSowingCells()
                }
              }
          )
        }
      }).catch(err => {
        loading.close()
        this.$alert(err.message, '获取失败', {
          confirmButtonText: "确认",
          callback: () => {
            this.loadSowingCells()
          }
        })
      })

    },

    toSowingDeliver(cell) {
      this.sowingDeliveryScanDialog = true
      this.sowingProductQrTexts = []
      this.sowingProductQrText = ''
      this.sowingCell = cell
      this.$nextTick(() => {
        this.$refs.scanSowingProductScanner.focus()
      })

    },

    scanSowingProductQrText() {
      const sowingProductQrText = this.sowingProductQrText
      this.sowingProductQrText = ''
      this.sowingProductQrTexts.unshift({
        id: uuid.getUUID(8, 16),
        qrText: sowingProductQrText,
        scanTime: timeUtil.format(new Date(), 'yy-MM-dd hh:mm:ss')
      })
      this.$message.success('扫码成功')
    },

    sowingProductQrTextInput(value) {
      this.sowingProductQrText = value + ''
    },

    doDeleteSowingProductQrText(row) {
      //console.log("row", row)
      const {id} = row
      const sowingProductQrTexts = this.sowingProductQrTexts
      this.$confirm('移除此条码记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.sowingProductQrTexts = sowingProductQrTexts.filter(item => item.id !== id)
      }).catch(() => {
      })
    },

    scanMultipleQrText() {
      const multipleQrText = this.multipleQrText
      if (!multipleQrText) {
        this.$message.warning('请扫码!')
        return
      }
      const columns = this.columns
      let cell = null
      if (this.isSowingCellQrCode(multipleQrText)) {
        for (let i = 0; i < columns.length; i++) {
          for (let j = 0; j < columns[i].length; j++) {
            if (multipleQrText === columns[i][j].qrCode) {
              cell = columns[i][j]
            }
          }
        }
        if (!cell) {
          this.$message.error('找不到播种框')
          return
        }
        this.multipleQrText = ''
        this.toSowingDeliver(cell)
      } else {
        const sowingWall = this.sowingWall
        const {id, teamId} = sowingWall
        const that = this
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })
        warehouseApi.scanMultipleQrText(multipleQrText, id, teamId).then(res => {
          this.multipleQrText = ''
          const {qrCode, status} = res
          let msg = ''
          if (status === 2) {
            msg += ', 已配齐'
          }
          this.$alert(`商品请置于播种框【${qrCode}】${msg}`, '提示', {
            confirmButtonText: '确定',
            callback: () => {
              that.loadSowingCells()
            }
          })
          loading.close()
        }).catch(err => {
          loading.close()
          this.$alert(err.message)
        })
      }
    },

    multipleQrTextInput(value) {
      this.multipleQrText = value + ''
    },
    multipleSearchQrTextInput(value) {
      this.multipleSearchQrText = value + ''
    },

    multiGroupQrTextInput(value) {
      this.multiGroupQrText = value + ''
    },

    toReleaseSowingCell(cell) {
      const {id, qrCode} = cell
      this.$confirm(`确认释放播种架【${qrCode}】?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })
        sowingApi.releaseSowingCell(id).then(() => {
          loading.close()
          this.$message.success('释放成功')
          this.loadSowingCells()
        }).catch(err => {
          loading.close()
          console.log("releaseSowingCell err", err)
          this.$alert(err.message, '释放失败')
        })
      }).catch(() => {
      })
    },

    getCellClassName({row, column, rowIndex, columnIndex}) {
      //console.log("row", row, "col", column, "rowIndex", rowIndex, "columnIndex", columnIndex)
      console.log("cell", row[columnIndex], "columnIndex", columnIndex, "row", row)
      if (columnIndex === 0) return ''
      const cell = row[columnIndex - 1]
      if (!cell) return ''
      if (cell.status === 1) {
        return 'warning-cell'
      } else if (cell.status === 2) {
        return 'success-cell'
      } else {
        return ''
      }
    },

    indexMethod(index) {
      return 'R' + (index + 1)
    },

    hideSowingWallScanner() {
      this.showScanSowingWall = false
    },

    scanSowingWallQrText() {
      let qrText = this.sowingWallQrText ? this.sowingWallQrText.trim() : ''
      qrText = encodeURIComponent(qrText)

      //调用根据 播种墙二维码 拿到播种墙实体的方法
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      sowingApi.findSowingCellByQrCode(qrText).then(res => {
        //console.log("qrText")
        this.sowingWall = {
          qrCode: res.qrCode,
          id: res.id,
          rowNum: res.rowNum,
          columnNum: res.columnNum
        }
        this.sowingWallQrText = ''
        this.showScanSowingWall = false
        this.loadSowingCells()
        loading.close()
      }).catch(err => {
        loading.close()
        this.$alert(err.message, '扫码失败')
      })

    },

    loadSowingCells() {
      const sowingWall = this.sowingWall
      const {id} = sowingWall
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      sowingApi.findSowingCellByParentAndStatus(id, null, 'true').then(list => {
        //console.log("findSowingCellByParentAndStatus list", list)
        let columns = new Array(sowingWall.rowNum)
        for (let i = 0; i < columns.length; i++) {
          columns[i] = new Array(sowingWall.columnNum)
        }
        list.map(item => {
          const {rowNum, columnNum} = item
          // console.log("rc", rowNum, columnNum)
          columns[rowNum - 1][columnNum - 1] = item
          return item
        })
        this.columns = columns
        loading.close()
      }).catch(err => {
        this.$alert(err.message, '加载播种架状态失败')
      })
    },

    sowingWallQrTextInput(value) {
      value += ''
      this.sowingWallQrText = value
    },

    toScanSowingQrCode() {
      this.showScanSowingWall = true
      this.$nextTick(() => {
        this.$refs.sowingWallScanner.focus()
      })
    },

    preHandleForView8() {

    },

    handleExpressDeliveryPageChange(val) {
      this.packageWaybillQuery(val - 1)
    },

    packageWaybillQuery(page) {
      page = page || 0
      const packageWaybill = this.packageWaybill || null
      const dates = this.dates
      let startTime = null
      let endTime = null
      if (dates && dates.length === 2) {
        startTime = dates[0]
        endTime = dates[1]
      }
      const query = {
        waybillId: packageWaybill,
        startTime,
        endTime,
        courierScan: this.courierUserSelected,
        userType: 2
      }
      const sessionKey = this.courierInfo.sessionKey
      this.expressDeliveryLoading = true
      afterSaleApi.expressDeliveryList(query, page, null, sessionKey).then(data => {
        this.expressDeliveryList = data.data
        this.pageInfo.page = data.page
        this.pageInfo.total = data.total
        this.expressDeliveryLoading = false
      }).catch(err => {
        this.$message.error(err.message)
        this.expressDeliveryLoading = false
      })

    },

    loadAndSaveCourier() {
      const courierId = '816545130'
      const token = UserTokenUtils.genLoginToken(courierId)
      userApi.userIdLogin(token).then(userInfo => {
        this.courierInfo = userInfo
      }).catch(err => {
        console.log("userIdLogin err", err)
      })
    },

    scanPackageWaybill() {
      const waybill = this.packageWaybill
      // const loading = this.$loading({
      //   lock: true,
      //   text: "Loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // })
      if (!waybill) {
        this.$message.warning("请扫描物流单号!")
        return
      }
      this.outerPopoverMsg = waybill
      this.outerPopVisible = true
      setTimeout(() => {
        this.outerPopVisible = false
      }, 3000)
      afterSaleApi.scanPackageByCourier(waybill, this.courierUserSelected).then(res => {
        this.packageWaybillList.unshift(res)
        if (this.packageWaybillList.length > 30) {
          this.packageWaybillList.pop()
        }
        this.packageWaybill = ''
        // loading.close()
      }).catch(err => {
        // this.$alert(err.message)
        this.$message.error(err.message)
        this.packageWaybill = ''
        //this.$message.error(err.message)
        // loading.close()
      })

    },

    showCurrentLogistics() {
      const logisticsId = this.logisticsId
      const companies = this.LOGISTICS_COMPANIES
      const index = companies.findIndex(com => com.value === logisticsId)
      let msg = ''
      if (index > -1) {
        msg = `当前快递【${companies[index].label}】`
      } else {
        msg = `快递码异常，请联系技术`
      }
      this.outerPopoverMsg = msg
      this.outerPopVisible = true
      setTimeout(() => {
        this.outerPopVisible = false
      }, 3000)

    },

    reprintLabelWholePack() {
      this.checkParam(this.printerCode, "请选择打印机")
      const afterSaleList = this.afterList
      this.reprintLabelWholePackRecursive(afterSaleList, 0)
    },

    reprintLabelWholePackRecursive(afterSaleList, index) {
      if (index < afterSaleList.length) {
        const after = afterSaleList[index]
        const items = after.items
        items.forEach(item => {
          this.reprintLabel(after, item)
        })
        this.reprintLabelWholePackRecursive(afterSaleList, index + 1)
      }
    },

    confirmRecWholePack(comment) {
      this.checkParam(this.printerCode, "请选择打印机")
      const afterSaleList = this.afterList
      this.$prompt("备注内容（50字以内）", "确认退货?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        inputValidator: () => {
          return true
        },
      }).then((value) => {
        if (value.action === "confirm") {
          let message = value.value || "";
          if (message.length > 50) {
            this.$alert("备注小于50字");
            return false;
          }
          this.confirmRecWholePackRecursive(afterSaleList, 0, message, comment)
        }
      })
    },

    confirmRecWholePackRecursive(afterSaleList, index, remark, comment) {
      if (index < afterSaleList.length) {
        const after = afterSaleList[index]
        const items = after.items
        items.forEach(item => {
          item.customRemark = remark
          let realComment = comment
          //赠品如果没有退款，实际调的是赠品的退款收货
          if (comment !== 0 && item.reasonDesc && item.reasonDesc.indexOf('赠品单退件') > -1 && item.aftersaleStatus === 0) {
            realComment = 0
          }
          this.processAfter(after, item, realComment)
        })
        this.confirmRecWholePackRecursive(afterSaleList, index + 1, remark, comment)
      }
    },

    cancelProductConfirm() {
      this.confirmDialog = false
      const productConfirm = this.productConfirm
      const {info} = productConfirm
      const {value} = info
      //此条码不算被扫过（没有实际去获取面单），因此去掉这条记录
      let index = texts.indexOf(value)
      if (index > -1) {
        texts.splice(index, 1)
      }
    },

    productConfirmForBatch: debounce(function () {
      //console.log('productConfirmForBatch!!')
      this.confirmDialog = false
      const productConfirm = this.productConfirm
      const {info} = productConfirm
      const {value, userId, logisticsId, amount, batchQrId} = info
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      this.scanQrTextQueue(value, userId, logisticsId, amount, loading, batchQrId, [])
    }, 150),

    handleWaybillKeyUp(e) {
      if (!this.waybillScanner) {
        this.waybillScanner = createScannerHandler({
          onComplete: qrText => {
            this.qrText = qrText
            this.waybillScan(this.event, null, true)
          },
          // onInput: qrText => this.qrText = qrText,
          maxInterval: 100
        })
      }
      this.waybillScanner.handleKeyUp(e)
    },

    handleKeyUp(e) {
      console.log("handleKeyUp e", e)
      let gap = 0
      let tempGap = 0
      if (this.keyUpLastTime) {
        gap = new Date().getTime() - this.keyUpLastTime
        if (gap > 50) {
          tempGap = gap
          gap = 0
          this.realBarCode = ""
          this.lastKey = ''
        }
      }
      this.keyUpLastTime = new Date().getTime()
      //输入法会触发keyUp事件，key为Process，直接跳过
      if (e.key != 'Process' && gap < 50) {
        console.log("+++", gap)
        if (e.key.trim().length == 1) {
          if (this.lastKey == 'Shift') {
            this.realBarCode += e.key.toUpperCase()
            this.lastKey = ''
          } else {
            this.realBarCode += e.key
          }
          if (gap < 30 && this.lastGap < 30) {
            this.continuousCount += 1
            this.fakeEnter = true
          } else {
            this.fakeEnter = false
            this.continuousCount = 0
          }
          this.lastGap = tempGap
          setTimeout(() => {
            if (this.fakeEnter && (new Date().getTime() - this.keyUpLastTime > 100) && this.barCode && this.continuousCount > 5) {
              this.showScan(this.barCode)
              this.fakeEnter = false
              this.continuousCount = 0
            }
          }, 100)

        } else if (e.key.trim() == 'Enter') {
          this.fakeEnter = false
          if (this.realBarCode) {
            console.log("扫码 Enter")
            this.barCode = this.realBarCode
            this.showScan(this.barCode)
            this.realBarCode = ""
          } else {
            console.log("手动 Enter", this.barCode)
            this.showScan(this.barCode)
            this.realBarCode = ""
          }
        } else if (e.key.trim() == 'Shift') {
          this.fakeEnter = false
          this.lastKey = e.key.trim()
        } else {
          this.fakeEnter = false
        }
      }
    },

    showScan(scanText) {
      this.scanWaybillId = scanText
      this.$message.success(scanText)
    },

    skuTest() {
      const arr = ['哈哈', '呵呵', '嘻嘻']
      const promiseMapper = ele => {
        return new Promise(resolve => {
          setTimeout(() => {
            console.log(ele, new Date().getTime())
            resolve()
          }, 5000)
        })
      }
      utils.promiseAllSequentially(arr, promiseMapper).then(() => {
        console.log('打印完成')
      }).catch(err => {
        console.log('err@', err)
      })
    },

    showOriginWaybill() {
      this.scanWaybillId = this.originWaybillId
      this.popVisible = true
      setTimeout(() => {
        this.popVisible = false
      }, 3000)
    },

    reprintIntercept(order) {
      this.checkParam(this.printerCode, "请选择打印机");
      let {waybill_id} = order
      let originWaybillId = null
      let acceptWaybill
      let yiboWaybill = waybill_id
      if (this.changeWaybillId) {
        //存在换单
        acceptWaybill = this.changeWaybillId
        originWaybillId = yiboWaybill
      } else {
        //没有换单，那么毅播发货的单号就是签收的单号
        acceptWaybill = yiboWaybill
      }
      const teamId = this.teamForIntercept
      afterSaleApi
          .reprintByWaybillId(acceptWaybill, this.userInfo.userId, this.printerCode, originWaybillId, null, teamId)
          .then((data) => {
            this.afterList = data
            this.$message("已打印")
          })
          .catch((err) => {
            if (err.message && err.message.indexOf('请切换到新系统') > -1) {
              this.vipName = err.message.split('-')[1] * 1
              this.$message.info('属于新系统客户的拦截件，已自动切换至新系统，请重新操作～')
              this.newSys = true
            } else {
              this.$alert(err.message)
            }
          })
    },
    labelPrinterChange(value) {
      console.log(value)
      this.printerCode = null
      if (value) {
        this.loadLocalPrinters()
      } else {
        this.loadPrinters()
      }
    },
    loadLocalPrinters() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      if (!local_printer.getConnect()) {
        local_printer.doConnect()
      }
      setTimeout(() => {
        local_printer.status().then(info => {
          local_printer.findAllDevice().then(data => {
            local_printer.getDeviceId().then(deviceId => {
              this.printerCodes = data.map(item => {
                return {
                  name: item,
                  code: deviceId + ":::" + item
                }
              })
              loading.close()
            }).catch(err => {
              this.$message(err)
              loading.close()
            })
          }).catch(err => {
            this.$message(err)
            loading.close()
          })
        }).catch(err => {
          this.$message(err)
          loading.close()
        })
      }, 1000 * 2)
    },
    loadPrinters() {
      const warehouseId = this.userInfo.warehouseId
      afterSaleApi.findAllPrinters(2, warehouseId).then(data => {
        this.printerCodes = data.map(item => {
          return {
            name: item.name,
            code: item.deviceId
          }
        })
      })
    },
    loadVips() {
      const warehouseId = this.userInfo.warehouseId
      packagedApi.vipUsers(warehouseId).then((vips) => {
        this.vips = vips
      })
    },

    testInsert() {
      let qrText = 'qrText' + cnter
      let waybillId = 'wbid' + cnter
      let orderId = 'oid' + cnter
      let item = {
        qrText,
        waybillId,
        orderId,
        status: Math.random() > 0.5 ? 0 : 1
      }
      cnter++
      //this.updatePrintDataList(item)
    },

    rowClick(row) {
      this.qrSelected = row.batchId
    },

    rowClick2(row) {
      const origin = this.selectedRow
      if (origin) {
        origin.checked = false
      }

      this.selectedRow = row
      this.$set(this.selectedRow, 'checked', true)
    },

    handleQrChange(val) {
      //console.log("--**", val)
    },

    handleLogisticsChange(val) {
      this.logisticsId = val
      localStorage.setItem(this.LOGISTICS_INFO, this.logisticsId + "");
      let company = this.getLogisticsCompany(val)
      this.$alert(`当前物流切换为「${company}」`, '注意', {
        confirmButtonText: '确定',
      })

      try {
        let deviceName = '未知'
        if (this.deviceMonitorView.id) {
          const op = this.deviceOptions.filter(op => op.id === this.deviceMonitorView.id)[0]
          if (op && op.deviceName) {
            deviceName = op.deviceName
          }
        }
        const info = {
          logisticsId: val,
          logisticsCompany: company,
          deviceId: this.deviceMonitorView.id,
          deviceName,
          userInfo: this.userInfo
        }
        // 记录变更信息
        errorUtils.uploadError('deviceLogisticsChange', JSON.stringify(info))
      } catch (e) {

      }
    },

    getLogisticsCompany(logisticsId) {
      const companies = this.LOGISTICS_COMPANIES
      const index = companies.findIndex(com => com.value * 1 === logisticsId * 1)
      if (index > -1) {
        return companies[index].label
      } else {
        return "未知快递：" + logisticsId
      }
    },

    addInterceptRemark(child) {
      this.$prompt('请输入仓库备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: child.interceptRemark
      }).then(({value}) => {
        let remark = value
        let waybillId = child.waybill_id
        const teamId = this.teamForIntercept
        afterSaleApi.addInterceptRemark(waybillId, remark, teamId).then(() => {
          this.$message.success('备注成功')
          //this.$set(row, 'failRemark', remark)
        }).catch(err => {
          this.$message.error(err.message)
          console.log('addInterceptRemark err', err)
        })
      }).catch(() => {

      })
    },


    realSkuSelect(order) {
      if (order) {
        this.afterSaleOrder = order
      } else {
        this.afterSaleOrder = {}
      }
      //清空关键字
      this.keyword = ''
      this.skuSelected = ''
      this.skuList2 = []
      this.update_sku_platform = order.platform === 2 ? 0 : order.platform
      //console.log('od',order, order.shopId)
      let {shopId, platform, tik_shop_id, appid, sellerId} = order
      // console.log("ord++", order)
      if (order.platform === 5) {
        //微信小商店
        shopId = shopId || appid
      } else if (order.platform === 12) {
        //蘑菇街
        shopId = sellerId || tik_shop_id
      } else {
        shopId = shopId || tik_shop_id
      }
      //是否自由打单
      let freeBill = false
      if (order.hasOwnProperty('order_id')) {
        if (order.order_id.length == 32) {
          freeBill = true
        }
      }
      if (platform !== 2 && !freeBill) {
        platform = platform + ''
        platformApi.findBindShopVoByShopId(shopId, platform).then(response => {
          console.log('findBindShopVoByShopId res', response)
          this.realTeamId = response.teamId
          //加载该团队的库存列表
          this.onLoadSkuList(null, null, null)
        }).catch(err => {
          console.log('findBindShopVoByShopId err', err)
          this.$message.error(err.message)
          return
        })
      } else if (freeBill) {
        this.realTeamId = order.appid
        this.onLoadSkuList(null, null, null)
      } else {
        this.realTeamId = shopId
        this.onLoadSkuList(null, null, null)
      }

      //显示对话框展示列表
      this.skuListDialogVisible = true
    },

    doKeywordSearchForStock() {
      let keyword = encodeURIComponent(this.keyword)
      if (keyword && keyword.length < 3) {
        this.$message({
          message: '关键字过短',
          type: 'warning'
        })
        return
      }
      this.skuSelected = ''
      if (!keyword) {
        this.onLoadSkuList(null, null, null)
        this.$data.skuList2 = []
        return
      }

      this.findStockByKeyword(keyword, 0)
      this.doKeywordSearchForOrder(keyword)
      this.doKeywordSearchForProduct(keyword)
    },

    doKeywordSearchForOrder(keyword) {
      this.skuListLoading2 = true
      this.dialog_page2 = 1
      this.skuList2 = []

      const platform = this.update_sku_platform || 0
      packagedApi
          .searchByKeyword(platform, keyword, 3, 90, this.realTeamId).then(response => {
        console.log('by keyword res', response)
        this.skuList2 = response.rows
        this.dialog_total2 = response.rows.length
        this.skuListLoading2 = false
      }).catch(err => {
        console.log('by keyword err', err)
        this.skuListLoading2 = false
      })

    },

    doKeywordSearchForProduct(keyword) {
      this.skuListLoading3 = true
      this.dialog_page3 = 1
      this.skuList3 = []

      const platform = this.update_sku_platform || 0
      packagedApi
          .searchByProductKeyword(keyword, this.realTeamId, platform).then(response => {
        console.log('by keyword res', response)
        this.skuList3 = response.rows
        this.dialog_total3 = response.rows.length
        this.skuListLoading3 = false
      }).catch(err => {
        console.log('by keyword err', err)
        this.skuListLoading3 = false
      })
    },

    confirmSku() {
      let skuId = this.skuSelected

      if (!skuId) {
        this.$message({
          message: '请勾选商品！',
          type: 'warning'
        })
        return
      }
      this.skuListDialogVisible = false
      let afterSaleOrder = this.afterSaleOrder
      // if(afterSaleOrder.afterSaleId) {
      //   console.log('售后件重打')
      // }else {
      //   console.log('拦截件重打')
      // }
      // return

      if (afterSaleOrder.aftersaleId) {
        this.$set(afterSaleOrder, 'realSku', this.skuSelected)
        let aftersaleId = afterSaleOrder.aftersaleId
        this.checkParam(this.printerCode, "请选择打印机")
        afterSaleApi.reprintByAfterSale(aftersaleId, this.printerCode, afterSaleOrder.realSku).then(() => {
          this.$message.success('重打标签成功!')
        }).catch(err => {
          console.log("reprintByAfterSale err", err)
          this.$alert(err.message, "重打错误", {
            confirmButtonText: "去解决",
          })
        })

      } else {
        this.checkParam(this.printerCode, "请选择打印机");
        let {waybill_id} = afterSaleOrder
        let originWaybillId = null
        let acceptWaybill
        let yiboWaybill = waybill_id
        // if(this.originWaybillId)
        //   originWaybillId = this.originWaybillId
        if (this.changeWaybillId) {
          //存在换单
          acceptWaybill = this.changeWaybillId
          originWaybillId = yiboWaybill
        } else {
          //没有换单，那么毅播发货的单号就是签收的单号
          acceptWaybill = yiboWaybill
        }
        const teamId = this.teamForIntercept
        afterSaleApi
            .reprintByWaybillId(acceptWaybill, this.userInfo.userId, this.printerCode, originWaybillId, skuId, teamId)
            .then((data) => {
              this.afterList = data
              this.$message("已打印")
            })
            .catch((err) => {
              this.$alert(err.message)
            })
      }

    },

    handleDialogCurrentChange(val) {
      console.log('page change :', val)
      this.skuSelected = ''
      let keyword = this.keyword
      if (!keyword) {
        this.onLoadSkuList(val - 1, null, null)
      } else {
        this.findStockByKeyword(keyword, val - 1)
      }
    },

    onLoadSkuList(page, size, skuId) {
      //加载动画
      this.skuListLoading = true
      const query = {
        page: page ? page : 0,
        size: size ? size : 20,
        teamId: this.realTeamId
      }

      remnantApi.findStocksV2(query).then((data) => {
        let list = data.data.map((item) => {
          return item
        })
        this.skuList1 = list
        this.skuListLoading = false
        this.dialog_page = data.page
        this.dialog_total = data.total
      }).catch(err => {
        console.log("findStockByUser err", err)
        this.skuListLoading = false
        this.$message.error(err.message)
      })

      // remnantApi
      //     .findStockByUser(page, size, this.realTeamId, skuId)
      //     .then((data) => {
      //       let list = data.data.map((item) => {
      //         return item
      //       })
      //       this.skuList1 = list
      //       this.skuListLoading = false
      //       this.dialog_page = data.page
      //       this.dialog_total = data.total
      //
      //     }).catch(err => {
      //   console.log("findStockByUser err", err)
      //   this.skuListLoading = false
      //   this.$message.error(err.message)
      // })

    },

    findStockByKeyword(keyword, page) {

      this.skuListLoading = true
      this.skuList1 = []

      const query = {
        page: page ? page : 0,
        size: this.dialog_size ? this.dialog_size : 20,
        teamId: this.realTeamId,
        keyword: this.keyword,
      }

      remnantApi.findStocksV2(query).then(response => {

        this.skuList1 = response.data
        this.dialog_total = response.total
        this.dialog_page = response.page
        this.skuListLoading = false
      }).catch(err => {
        console.log('stock by keyword err', err)
        this.skuListLoading = false
      })

      // remnantApi
      //     .findStockByKeyword(keyword, this.realTeamId, [], page, this.dialog_size).then(response => {
      //
      //   this.skuList1 = response.data
      //   this.dialog_total = response.total
      //   this.dialog_page = response.page
      //   this.skuListLoading = false
      // }).catch(err => {
      //   console.log('stock by keyword err', err)
      //   this.skuListLoading = false
      // })
    },

    toUnusual() {
      let waybillId = this.afterWaybillId
      // if(!waybillId) {
      //   if(!this.qrText) {
      //     this.$message.warning('物流单号栏不能为空,请输入')
      //     return
      //   }
      //   waybillId = this.qrText
      // }
      let unusual = this.unusual
      // let unusualItem = this.unusuals[unusual - 1]
      const unusualItem = this.unusuals.find(unItem => unItem.code === unusual)
      let userId = this.userInfo.userId
      let teamId = this.vipName
      if (!waybillId || !unusual) {
        this.$message("没有物流单号或未选异常原因")
        return false
      }
      this.$prompt(
          `异常原因:${unusualItem.name}`,
          `是否将${waybillId}转交异常处理`
      ).then((value) => {
        console.log(value)
        if (value.action === 'confirm') {
          let description = value.value
          afterSaleApi.unusualRecord(waybillId, unusual, description, userId, teamId).then(res => {
            this.$message('已提交！')
            this.afterWaybillId = null
          }).catch(err => {
            this.$confirm(err.message, '提交失败')
          })
        }
      });
    },
    submitExchangeUnusualRecord(context) {
      return afterSaleApi.unusualRecord(
          context.waybillId,
          8,
          context.description,
          this.userInfo.userId,
          context.teamId
      )
    },
    batchReprint() {
      let selections = this.waybillSelections;
      if (!selections || !selections.length) {
        this.$message.error("请勾选需要重打的面单");
        return;
      }
      let len = selections.length;

      this.$confirm(`确认重打勾选的面单,共「${len}」单?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.$message({
              message: "重打中...",
              type: "success",
            });
            selections.forEach((item) => {
              this.reprintWaybill(item.waybillId);
            });
            this.waybillSelections = []
          })
          .catch(() => {
          });
    },

    handleSelectionChange(selections) {
      this.waybillSelections = selections;
    },

    handleYTClick() {
      this.checkParam(this.superior, "请获得管理员权限再切换物流");
      this.$confirm("确认将当前物流切换为「圆通」?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.logisticsId = 7;
            localStorage.setItem(this.LOGISTICS_INFO, this.logisticsId + "");
            this.ytLogistics = "success";
            this.ztLogistics = "danger";
            this.ydLogistics = "danger";
            this.$message({
              message: "当前物流切换为「圆通」",
              type: "success",
            });
          })
          .catch(() => {
          });
    },
    handleZTClick() {
      this.checkParam(this.superior, "请获得管理员权限再切换物流");
      this.$confirm("确认将当前物流切换为「中通」?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.logisticsId = 15;
            localStorage.setItem(this.LOGISTICS_INFO, this.logisticsId + "");
            this.ytLogistics = "danger";
            this.ydLogistics = "danger";
            this.ztLogistics = "success";

            this.$message({
              message: "当前物流切换为「中通」",
              type: "success",
            });
          })
          .catch(() => {
          });
    },
    handleYDClick() {
      this.checkParam(this.superior, "请获得管理员权限再切换物流");
      this.$confirm("确认将当前物流切换为「韵达」?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.logisticsId = 9;
            localStorage.setItem(this.LOGISTICS_INFO, this.logisticsId + "");
            this.ytLogistics = "danger";
            this.ztLogistics = "danger";
            this.ydLogistics = "success";

            this.$message({
              message: "当前物流切换为「韵达」",
              type: "success",
            });
          })
          .catch(() => {
          });
    },

    rejectAfter(after, item, comment) {
      // console.log(a, b , c)
      this.$prompt("请输入备注(50字以内)", "确认拒绝退货?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        inputValidator: () => {
          return true;
        },
      }).then((value) => {
        if (value.action === "confirm") {
          let message = value.value || "";
          if (!message) {
            this.$alert("请填写拒绝详细原因");
            return false;
          }
          if (message.length > 50) {
            this.$alert("备注小于50字");
            return false;
          }
          item.customRemark = message;
          this.processAfter(after, item, comment);
        }
      });
    },
    reprintDefect(after, item) {
      let remark = after.orderVo ? after.orderVo.seller_remark : ""
      this.$prompt('请输入次品描述', '提示', {
        inputValue: remark || '',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({value}) => {
        if (!value) {
          this.$message.warning('请输入次品描述！')
          return
        }
        this.reprintLabel(after, item, value)
      }).catch(() => {

      })
    },

    reprintLabel(after, item, defect) {
      let aftersaleId = after.aftersaleId;
      this.checkParam(this.printerCode, "请选择打印机");
      afterSaleApi.reprintByAfterSale(aftersaleId, this.printerCode, null, defect).then(() => {
        this.$message.success('已重打')
      }).catch(err => {
        console.log('reprintByAfterSale err', err)
        this.$message.error(err.message)
      })
    },
    confirmRec(after, item, comment) {
      this.checkParam(this.printerCode, "请选择打印机");
      //如果是心选赠品单仅收货且未退款, 则实际调取退款售后接口
      if (comment === 2 && item.reasonDesc && item.reasonDesc.indexOf('赠品单退件') > -1 && item.aftersaleStatus === 0) {
        comment = 0
      }
      this.$prompt("备注内容（50字以内）", "确认退货?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        inputValidator: () => {
          return true;
        },
      }).then((value) => {
        if (value.action === "confirm") {
          let message = value.value || "";
          if (message.length > 50) {
            this.$alert("备注小于50字");
            return false;
          }
          item.customRemark = message;
          this.processAfter(after, item, comment);
        }
      });
    },
    processAfter(after, item, comment) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let info = item;
      info.aftersaleId = after.aftersaleId;
      info.shopId = after.shopId;
      info.hasGivenOrders = after.hasGivenOrders
      //info.waybillId = this.afterWaybillId;
      afterSaleApi
          .processAfterSale(
              comment,
              this.vipName,
              this.printerCode,
              info,
              this.userInfo.userId
          )
          .then(() => {
            // this.$alert('处理完成')
            let waybill = null;
            if (this.afterList.length <= 1) {
              // waybill = this.qrText;
              // this.qrText = "";
            }
            loading.close();
            this.$message.success('处理完成')
            this.$set(after, 'refundStatusDesc', '处理完成')
            if (this.shouldPromptExchangeUnusual(comment)) {
              this.confirmExchangeUnusual({
                after,
                items: [item],
                teamId: this.vipName,
                waybillId: info.waybillId || this.afterWaybillId
              })
            }
            // setTimeout(() => {
            //   this.waybillScan(null, waybill, false);
            // }, 1000 * 2);
          })
          .catch((err) => {
            this.$alert(err.message);
            loading.close();
          });
    },
    // 前置检查是否已经选择了客户
    beforeSearchAfterSales(waybill, callback) {
      if (!this.vipName) {
        const loading = this.$loading({
          text: '正在识别客户...',
          spinner: 'el-icon-loading'
        });
        afterSaleApi.findTeamByAfterSaleWaybillId(waybill)
            .then(teamId => {
              loading.close();
              if (teamId) {
                // 调用 changeVip 并传递回调，在客户切换完成后执行查询
                this.changeVip(teamId, () => {
                  callback && callback();
                });
              } else {
                this.$message.error('无法识别物流单所属客户，请手动选择');
              }
            })
            .catch(err => {
              loading.close();
              console.error('识别团队失败:', err);
              this.$message.error('识别客户失败：' + err.message);
            });
      } else {
        callback && callback();
      }
    },

    waybillScan(event, waybill, showQrText) {
      let loadingComponent = null;
      if (!showQrText) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        loadingComponent = loading;
      }

      if (this.qrText) {
        waybill = this.qrText;
      }

      let teamId = this.vipName;

      if (this.workMode === 0 || this.workMode === 3) {
        this.scanWaybillId = waybill;
        if (showQrText) {
          this.popVisible = true;
          setTimeout(() => {
            this.popVisible = false;
          }, 3000);
        }
        let onlySearch = this.workMode === 0 ? 0 : 1
        this.afterWaybillId = waybill;
        this.afterList = []
        const requestID = this.getRequestID()
        this.currentRequestID = requestID
        this.beforeSearchAfterSales(waybill, () => {
          const teamId = this.vipName;
          afterSaleApi
              .searchAfterSales(waybill, teamId, this.userInfo.userId, onlySearch)
              .then((data) => {
                console.log(data);
                if (this.currentRequestID === requestID) {
                  this.afterList = data

                  if (!data || !data.length) {
                    this.$message.warning('暂无数据')
                  }
                  if (loadingComponent) loadingComponent.close()
                }
              })
              .catch((err) => {
                if (this.currentRequestID === requestID) {
                  if (loadingComponent) loadingComponent.close()
                  this.$message(err.message)
                }
              });
        });
      } else if (this.workMode === 1) {
        //this.checkParam(this.printerCode, "请选择打印机");
        this.scanWaybillId = waybill;
        if (showQrText) {
          this.popVisible = true;
          setTimeout(() => {
            this.popVisible = false;
          }, 3000);
        }
        this.afterWaybillId = waybill
        const originWaybillId = this.originWaybillId
        if (originWaybillId) {
          if (!waybill) {
            if (loadingComponent) loadingComponent.close();
            this.$alert('实收物流单号不能为空!')
            return
          }
          this.changeWaybillId = waybill
          waybill = this.originWaybillId
        } else {
          this.changeWaybillId = ''
        }

        this.waybillInterceptPreQueryPromise(waybill, teamId).then(result => {
          if (result) {
            if (loadingComponent) loadingComponent.close()
            if (result < 2) {
              this.waybillScan()
              return
            }
          } else {
            this.teamForIntercept = teamId
            this.afterList = []
            const requestID = this.getRequestID()
            this.currentRequestID = requestID
            afterSaleApi.searchWaybillInterceptOrder(waybill, teamId).then(data => {
              if (this.currentRequestID === requestID) {
                this.afterList = data
                if (loadingComponent) loadingComponent.close()
              }
              //this.$message("已打印");
            }).catch((err) => {
              const {message} = err
              if (loadingComponent) loadingComponent.close()
              if (message.includes('没找到相关订单信息')) {
                this.$alert('非毅播发货，没找到相关订单信息，请确认团队是否选择正确', '错误提示')
              } else if (message.includes('请切换为正确的团队')) {
                const rightTeamId = message.split('：')[1] * 1
                const rightTeam = this.getVipByTeamId(rightTeamId)
                if (rightTeam) {
                  const needChangeSys = !!(rightTeam.version)
                  const callback = needChangeSys ? null : () => {
                    this.waybillScan()
                  }
                  this.changeVip(rightTeamId, callback)
                } else {
                  this.$alert('非毅播发货，团队选择错误，请手动切换正确的团队', '错误提示')
                }
              } else {
                if (this.currentRequestID === requestID) {
                  this.$alert(err.message, '错误提示')
                }
              }
            })
          }
        }).catch(err => {
          this.$alert(err.message, '提示')
        })
      } else if (this.workMode === 2) {
        this.productItem = {};
        afterSaleApi
            .recreateQrCode(
                waybill,
                teamId,
                this.userInfo.userId,
                this.printerCode
            )
            .then((res) => {
              console.log("recreateQrCode res", res);
              this.productItem = res;
              this.$message("已打印");
              if (loadingComponent) loadingComponent.close();
              this.productDialogVisible = true;
            })
            .catch((err) => {
              console.log("recreateQrCode err", err);
              if (loadingComponent) loadingComponent.close();
              this.$alert(err.message);
            });
      }
    },
    toDown(type) {
      // console.log(this.userInfo)
      // console.log(type)
      let time = this.timeRange;
      let teamId = this.vipName;
      let platform = this.platform;
      let upType = this.upType;
      let allUser = this.allUser;
      // console.log(type, time, teamId)
      let downUrl = "http://api.yiboerp.com/yifahuo/";
      if (type === 0) {
        this.checkParam(
            this.userInfo.roles.includes("WarehouseSuperior"),
            "权限不足"
        );
        // 发货
        this.checkParam(time.length === 2, "请选择时间范围");
        this.checkParam(teamId, "请选择客户");
        downUrl += `package/exportWarehouseDetail?teamId=${teamId}&startTime=${time[0]}&endTime=${time[1]}&platform=${platform}`;
      } else if (type === 1) {
        this.checkParam(
            this.userInfo.roles.includes("WarehouseSuperior"),
            "权限不足"
        );
        // 实时库存
        this.checkParam(teamId || allUser, "请选择客户");
        if (allUser) {
          downUrl += `package/exportRemnantStock`;
        } else {
          downUrl += `package/exportRemnantStock?teamId=${teamId}`;
        }
      } else if (type === 2) {
        this.checkParam(
            this.userInfo.roles.includes("WarehouseSuperior"),
            "权限不足"
        );
        this.checkParam(teamId || allUser, "请选择客户");
        this.checkParam(time.length === 2, "请选择时间范围");
        if (upType != null) {
          downUrl += `package/exportUpDownRecord?teamId=${teamId}&startTime=${time[0]}&endTime=${time[1]}&type=${upType}`;
        } else {
          downUrl += `package/exportUpDownRecord?teamId=${teamId}&startTime=${time[0]}&endTime=${time[1]}`;
        }
      } else if (type === 3) {
        this.checkParam(
            this.userInfo.roles.includes("WarehouseSuperior"),
            "权限不足"
        );
        this.checkParam(teamId, "请选择客户");
        teamId = this.teamId;
        warehouseApi
            .assureFinished(teamId)
            .then((data) => {
              // console.log(data)
              this.$alert("提交成功");
            })
            .catch((err) => {
              this.$alert(err.message);
            });
      } else {
        this.checkParam(teamId, "请选择客户");
        this.checkParam(time.length === 2, "请选择时间范围");
        // http://localhost:10202/package/exportRemnantLogGroup?teamId=512056&startTime=2020-01-01%2010:00:00&endTime=2022-01-01%2010:00:00
        downUrl += `package/exportRemnantLogGroup?teamId=${teamId}&startTime=${time[0]}&endTime=${time[1]}`;
      }

      if (type !== 3) {
        window.location.href = downUrl;
      }
    },
    errOrder(row) {
      let id = row.id;
      this.$confirm(row.waybillId + "实际未发出?", "异常订单标记", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        warehouseApi
            .errOrderSign(id)
            .then(() => {
              this.$message("完成");
            })
            .catch((err) => {
              this.$alert(err.message);
            });
      });
    },
    checkParam(p, msg) {
      if (!p) {
        this.$message(msg);
        throw msg;
      }
      return p;
    },
    taskGroupDetail() {
      let taskGroup = this.taskGroup;
      if (!taskGroup.id) {
        this.$message("仅批次可批量打单");
        return false;
      }
      let multipleOrders = this.multipleOrders;
      if (multipleOrders.length <= 0) {
        this.$message("无批量打单需求");
        return false;
      }

      let ids = multipleOrders.map((it) => {
        return it.order_id;
      });

      let groupSize = 3
      let groups = []
      // 将ids进行分组，暂时是三个一组, 更改groupSize即可
      for (let i = 0; i * groupSize < ids.length; i++) {
        let start = i * groupSize
        let end = Math.min(i * groupSize + groupSize, ids.length)
        let group = ids.slice(start, end)
        groups.push(group)
      }

      this.$confirm(taskGroup.title + "确认配齐?", "批量打单提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let userId = this.userInfo.userId;
        if (!userId) {
          this.$message.error("请先登录");
          return false;
        }
        let logisticsId = this.logisticsId;
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        let promises = []
        groups.forEach(g => {
          const task = this.buildMultiOrderSendPromise(g, logisticsId, userId)
          promises.push(task)
        })
        let errorList = []
        Promise.all(promises).then(resultList => {
          // 多件打印之后，自动消除扫码输入的二维码条码
          this.multipleSearchQrText = ''
          // 重新加载多件任务列表
          this.changeVip(this.teamId, true)
          // 收集打印结果
          // 成功的单数
          let success = 0
          let fail = 0
          let stAdvised = 0, ytAdvised = 0, ztAdvised = 0, sfAdvised = 0, jdAdvised = 0
          resultList.forEach(result => {
            if (result.status === 0) {
              success += result.success
            } else {
              if (result.data) {
                success += result.success
                fail += result.fail
                const {data} = result
                if (data && data.length) {
                  data.forEach(printData => {
                    if (printData.status === 12) {
                      const {errorMsg} = printData
                      if (errorMsg.indexOf('请用申通') > -1) {
                        stAdvised++
                      } else if (errorMsg.indexOf('请用圆通') > -1) {
                        ytAdvised++
                      } else if (errorMsg.indexOf('请用中通') > -1) {
                        ztAdvised++
                      } else if (errorMsg.indexOf('请用顺丰') > -1) {
                        sfAdvised++
                      } else if (errorMsg.indexOf('请用京东') > -1) {
                        jdAdvised++
                      }
                    }
                  })
                }
              } else {
                fail += result.errNum
                errorList.push(`获取【${result.errNum}】个面单失败，原因：` + result.errMsg)
              }
            }
          })

          const multiSendResultMap = this.multiSendResult
          if (multiSendResultMap.has(taskGroup.id)) {
            const result = multiSendResultMap.get(taskGroup.id)
            const {totalStAdvised, totalYtAdvised, totalZtAdvised, totalSfAdvised, totalJdAdvised} = result
            const multiSendResult = {
              stAdvised,
              ytAdvised,
              ztAdvised,
              sfAdvised,
              jdAdvised,
              totalStAdvised: totalStAdvised + stAdvised,
              totalYtAdvised: totalYtAdvised + ytAdvised,
              totalZtAdvised: totalZtAdvised + ztAdvised,
              totalSfAdvised: totalSfAdvised + sfAdvised,
              totalJdAdvised: totalJdAdvised + jdAdvised
            }
            multiSendResultMap.set(taskGroup.id, multiSendResult)
          } else {
            const multiSendResult = {
              stAdvised,
              ytAdvised,
              ztAdvised,
              sfAdvised,
              jdAdvised,
              totalStAdvised: stAdvised,
              totalYtAdvised: ytAdvised,
              totalZtAdvised: ztAdvised,
              totalSfAdvised: sfAdvised,
              totalJdAdvised: jdAdvised
            }
            multiSendResultMap.set(taskGroup.id, multiSendResult)
          }
          let tips = `成功打印${success}单,失败${fail}单<br/>`
          if (stAdvised) {
            tips += `请用【申通】：【${stAdvised}】单<br/>`
          }
          if (ytAdvised) {
            tips += `请用【圆通】：【${ytAdvised}】单<br/>`
          }
          if (ztAdvised) {
            tips += `请用【中通】：【${ztAdvised}】单<br/>`
          }
          if (sfAdvised) {
            tips += `请用【顺丰】：【${sfAdvised}】单<br/>`
          }
          if (jdAdvised) {
            tips += `请用【京东】：【${jdAdvised}】单<br/>`
          }

          if (errorList && errorList.length) {
            errorList.forEach(errMsg => {
              tips += `${errMsg}<br/>`
            })
          }

          if (fail > 0) {
            this.$alert(
                tips,
                "有订单异常",
                {
                  confirmButtonText: "错误详情",
                  dangerouslyUseHTMLString: true
                }
            )
          } else {
            this.$alert(`成功打印${success}单`, "获取成功", {
              confirmButtonText: "确认",
            })
          }
        })

      })
    },
    toConfirmCreate() {
      if (!this.taskSku || this.taskSku.length === 0) {
        this.$message("款式选择错误")
        return false
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      // let skuId = this.taskSku.skuId
      const mo = this.taskSku.map(sk => {
        return {
          num: 1,
          skuId: sk.skuId
        }
      })
      let modal = {
        teamId: this.teamId,
        modals: mo
        // platform: null 暂时没有设置
      }
      console.log(modal)
      warehouseApi
          .creatMultipleTaskGroup(modal)
          .then((data) => {
            let taskGroups = this.taskGroups;
            taskGroups.push(data);
            this.taskGroup = data;
            this.taskGroups = taskGroups;
            this.changeVip(this.teamId, true);
            this.taskGroupCreateViewable = false;
            loading.close();
          })
          .catch((err) => {
            this.$alert(err.message);
            loading.close();
          });
    },
    changeTaskGroup(e, clearText) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let taskGroup = this.taskGroup
      let multipleSearchQrText = this.multipleSearchQrText || null
      let size = taskGroup.id ? this.multiPageSize : null
      warehouseApi.findMultipleOrder(this.teamId, taskGroup.id || null, multipleSearchQrText, null, size).then((data) => {
        this.multipleOrders = data
        if (clearText) {
          this.multipleSearchQrText = ''
        }
        loading.close()
      }).catch(err => {
        this.$message(err.message)
        loading.close()
      });
    },
    changePrinter(value) {
      this.printerCode = value;
    },
    changeTaskSku(value) {
      this.taskSku = value;
    },
    getSkuFromQrText() {
      let value = this.qrTextInfo
      let taskSku = this.taskSku
      warehouseApi.getSkuFromQrText(value).then(info => {
        let cf = taskSku.filter(item => {
          return item.skuId === info.skuId
        })
        if (cf.length > 0) {
          this.$message('重复了')
          return false
        }
        taskSku.push(info)
        this.taskSku = taskSku
      })
    },
    createTaskGroupByScan() {
      this.qrTextInfo = ''
      this.taskSku = []
      this.taskGroupCreateViewable = true
    },
    createMultipleTaskGroupByOrderNum() {
      let taskGroup = this.taskGroup;
      if (taskGroup.id) {
        this.$message("请切换为未分配批次");
        return false;
      }
      let orders = this.multipleOrders;
      if (orders.length === 0) {
        this.$message("没有可以创建的内容，刷新重试");
        return false
      }
      this.$confirm('是否创建').then(res => {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })
        // console.log(res)
        if (res === 'confirm') {
          warehouseApi
              .createMultipleTaskGroupByOrderNum(this.teamId)
              .then((data) => {
                let taskGroups = this.taskGroups;
                let group = data[0]
                taskGroups.push(...data);
                this.taskGroup = group;
                this.taskGroups = taskGroups;
                this.changeVip(this.teamId, true);
                loading.close();
              })
              .catch((err) => {
                this.$alert(err.message);
                loading.close();
              });
        }
      })
    },
    createTaskGroup() {
      let taskGroup = this.taskGroup;
      if (taskGroup.id) {
        this.$message("请切换为未分配批次");
        return false;
      }
      // 抓取款式
      let orders = this.multipleOrders;
      if (orders.length === 0) {
        this.$message("没有可创建内容");
        return false;
      }

      let skuList = [];
      let skuSet = new Set();
      for (let i = 0; i < orders.length; i++) {
        for (let j = 0; j < orders[i].children.length; j++) {
          // console.log(i, j, orders[i].children)
          let item = orders[i].children[j]
          let cid = item.skuId;
          if (skuSet.has(cid)) {
            continue
          }

          // 暂不处理 件数大于1件的组合
          if (item.combo_num > 1) {
            continue
          }
          skuSet.add(cid);
          skuList.push(orders[i].children[j]);
        }
      }

      if (skuList.length === 0) {
        this.$message("无可创建批次的款式");
        return false;
      }
      this.skuList = skuList;
      this.qrTextInfo = ''
      this.taskGroupCreateViewable = true;
    },
    // 发货异常高亮显示
    tableRowClassName({row, rowIndex}) {
      let str = ''
      if (row.message && row.message.includes('获取成功')) {
        str += "success-row"
      } else {
        str += "warning-row"
      }

      if (row.checked) {
        str += ' select-row'
      }
      return str
    },
    // 发货异常高亮显示
    highlightSelected({row, rowIndex}) {
      let cls = ''
      if (row.batchId === this.qrSelected) {
        cls += 'success-row1'
      }

      if (row.error) {
        cls += ' warning-row'
      }
      return cls
    },

    queryByQrText() {
      let qrText = this.qrCode;
      warehouseApi
          .findSkuSendRecord(qrText, 36)
          .then((data) => {
            data = data.map((o) => {
              let actionStatus = o.actionStatus;
              o.orderStatus = this.statusMap[actionStatus];
              o.orderId =
                  o.totalNum > 1 ? `共${o.totalNum}含${o.num}件` : o.orderId;
              return o;
            });
            this.records = data;
          })
          .catch((err) => {
            this.$message(err.message);
          });
    },

    // 异常查询高亮显示
    tableRowclassName_inquire({row, rowIndex}) {
      if (row.actionStatus !== 10) {
        return "warning-row";
      } else if (row.logisticsStatus.indexOf("未揽收") > -1) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },

    reprintByQrCode() {
      let qrCode = this.qrCode;
      this.$confirm('确认要重新打印面单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.reprintWaybill(qrCode)
        this.qrCode = ''
      }).catch(() => {
        this.$message.info('已取消重打面单')
      })

      this.qrCode = ''
    },
    reprintWaybill(waybillId) {
      let printerName = this.printerName;
      // 物流单号重打
      warehouseApi
          .reprintOrder(waybillId)
          .then((data) => {
            if (data.status == 0) {
              this.waybillPopoverQueueUpdate(data.waybillId)
              this.displayWaybillsByPopoverManager()
              cloudprint
                  .doPrint(data, printerName, true)
                  .then(() => {
                    // this.$message("获取成功");
                  })
                  .catch((err) => {
                    this.$alert(err.message, "打印错误", {
                      confirmButtonText: "去解决",
                    });
                  });
            } else {
              this.$alert(data.errorMsg, "打印错误", {
                confirmButtonText: "去解决",
              });
            }
          })
          .catch((err) => {
            this.$message(err.message);
          });
    },
    sendOrder(order, idx) {
      console.log(order, idx);
      this.$confirm("是否确认已经配齐?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            let printerName = this.printerName;
            let logisticsId = this.logisticsId;
            let userId = this.userInfo.userId;
            if (!userId) {
              this.$message.error("请先登录");
              return false;
            }
            warehouseApi
                .multipleOrderSend(order.order_id, logisticsId, userId)
                .then((printData) => {
                  // 多件打印之后，自动消除扫码输入的二维码条码
                  this.multipleSearchQrText = ''
                  if (printData.status === 0) {
                    const {waybillId} = printData
                    this.popoverManager.queue.push(waybillId)
                    cloudprint
                        .doPrint(printData, printerName)
                        .then(() => {
                          this.$alert(printData.errorMsg, "获取成功", {
                            confirmButtonText: "确定",
                          });
                          this.changeVip(this.teamId, true);
                        })
                        .catch((err) => {
                          this.$alert(err.message, "打印错误", {
                            confirmButtonText: "去解决",
                            callback: action => {
                              this.changeVip(this.teamId, true)
                            }
                          });
                        });
                    this.displayWaybillsByPopoverManager()
                  } else {
                    this.$alert(printData.errorMsg, "打印错误", {
                      confirmButtonText: "去解决",
                      callback: action => {
                        this.changeVip(this.teamId, true)
                      }
                    });
                  }
                })
                .catch((err) => {
                  this.$alert(err.message, "多件发货错误", {
                    confirmButtonText: "去解决",
                    callback: action => {
                      this.changeVip(this.teamId, true)
                    }
                  });
                });
          })
          .catch((err) => {
            this.$alert(err.message, "多件发货错误", {
              confirmButtonText: "放入库存区",
            });
          });
    },
    changeView(view) {
      // console.log(view);
      if (view === 6 || view === 5 || view === 2 || view === 8 || view === 10) {
        this.checkParam(this.userInfo.userId, "请先登录");
      }
      const lastView = this.view
      this.view = view
      if (lastView === 8 && view !== 8) {
        this.changeVip(this.vipName)
      } else if (view === 8) {
        this.loadSowingRecords()
      }
    },

    getPrinters() {
      try {
        !printer.getConnect() && (printer.doConnect())
        !davinci_printer.getConnect() && (davinci_printer.doConnect())
        !ks_printer.getConnect() && (ks_printer.doConnect())
        !pddPrinter.getConnect() && (pddPrinter.doConnect())
        !channelPrinter.getConnect() && (channelPrinter.doConnect())
        !xhsPrinter.getConnect() && (xhsPrinter.doConnect())
      } catch (e) {
        console.log('tryConnect err', e)
      }
      const printerServices = [
        davinci_printer,
        printer,
        ks_printer,
        pddPrinter,
        channelPrinter,
        xhsPrinter
      ]
      const promises = []
      printerServices.forEach(printerService => {
        if (printerService.getConnect()) {
          promises.push(printerService.getPrinters())
        }
      })
      if (!promises.length) return

      let defaultPrinter = null
      const printerSet = new Set()
      Promise.all(promises).then(resultList => {
        this.printers = resultList.flatMap(result => {
          if (!defaultPrinter && result.defaultPrinter) {
            defaultPrinter = result.defaultPrinter
          }
          return result.printers
        }).filter(ptr => {
          if (printerSet.has(ptr.name)) {
            return false
          }
          printerSet.add(ptr.name)
          return true
        })
        this.printerName = defaultPrinter
      }).catch(err => {
        this.$message.error('打印机刷新失败：' + JSON.stringify(err))
        console.log('getPrinters err', err)
      })
    },

    printTest() {
      this.waybillPopoverQueueUpdate('YT8130469286500')
      this.waybillPopoverQueueUpdate('YT8130469286500')
      this.waybillPopoverQueueUpdate('YT8130469286500')
      this.waybillPopoverQueueUpdate('YT8130469286500')
      this.displayWaybillsByPopoverManager()
    },
    qrTextInput(value) {
      // console.log("value", value)
      value += "";
      this.qrText = value;
    },

    packageWaybillInput(value) {
      value += ""
      this.packageWaybill = value
    },

    qrCodeInput(value) {
      this.qrCode = value;
    },
    scanQrText: debounce(function (e, re) {
      let value = this.qrText;
      // console.log("qrText", value, e)
      if (value.startsWith("UID") || value.startsWith("uid")) {
        // 用户登录
        //let userId = value.substring(3);
        let token = value.toString()
        userApi.userIdLogin(token).then(userInfo => {
          this.userInfo = userInfo
          request.setSessionKey(userInfo.sessionKey)
          this.loadPrinters()
          this.loadVips()
          this.showCurrentLogistics()
          this.boxSendView.notify()
          this.deviceMonitorView.loadList()
          this.loginConnect = "success"
          this.qrText = ""
          // 清空面单来源
          this.matchChannel = ''
          this.resetLastScanTimer()
        }).catch(err => {
          console.log("userIdLogin err", err)
          this.$message.error(err.message)
        })
        return false;
      }

      let userId = this.userInfo.userId;
      if (!userId) {
        this.$message.error("请先登录");
        return false;
      }

      if (!this.matchChannel) {
        this.$message.error('请选择配单来源')
        return false
      }

      if (!value || value.length <= 4) {
        this.$message.error("条码数据格式错误");
        return false;
      }

      if (texts.indexOf(value) > -1 && !re) {
        this.$message.error("该标签被扫描过!");
        this.$confirm(
            "如果是长时间未出单请耐心等待，或找主管处理！",
            "确定重复扫码？"
        )
            .then((res) => {
              this.scanQrText(e, true);
            })
            .catch((err) => {
            });
        return false;
      }

      const batchQrId = uuid.getUUID(8, 16)

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      if (value.endsWith("V3")) {
        let splits = value.split("-");
        if (splits[1] != "1") {
          texts.push(value);
        }
      } else if (value.endsWith("V2")) {
        let splits = value.split(":");
        if (splits[1] != "1") {
          texts.push(value);
        }
      } else if (value.endsWith("AL")) {
        let splits = value.split("-")
        if (splits[1] != "1") {
          texts.push(value)
        }
      } else {
        //其余的不处理
      }

      let amount = 1;
      let strs = value.split("-");
      if (strs.length === 7) {
        try {
          amount = parseInt(strs[1]);
        } catch (e) {
          this.$message.error("标签格式错误" + value);
          console.error(e);
          loading.close();
          return false;
        }
      }

      let logisticsId = this.logisticsId;

      // 重置定时器
      this.resetLastScanTimer()

      if (amount > 10) {
        this.getProductInfoFromQrTextPromise(value).then(sku => {
          const {image, productName, code, specs} = sku
          this.productConfirm = {
            productPic: image,
            productName: productName,
            specs: specs,
            code: code,
            info: {
              value,
              userId,
              logisticsId,
              amount,
              batchQrId
            }
          }
          loading.close()
          this.confirmDialog = true
        })
      } else {
        this.scanQrTextQueue(value, userId, logisticsId, amount, loading, batchQrId, [])
      }
    }, 150),

    scanQrTextQueue(value, userId, logisticsId, amount, loading, batchQrId, extraInfoList) {
      if (amount <= 0) {
        //弃用全局batchId
        //batchId++
        loading.close();
        if (extraInfoList && extraInfoList.length) {
          this.$alert(`商家特殊备注有【${extraInfoList.length}】单，请注意`, '提示')
        }
        return false;
      }
      let num = amount >= 3 ? 3 : amount;
      this.scanQrTextNext(value, userId, logisticsId, num, batchQrId, extraInfoList)
          .then(() => {
            // console.log('manager', this.popoverManager)
            this.displayWaybillsByPopoverManager()
            amount -= 3;
            this.scanQrTextQueue(value, userId, logisticsId, amount, loading, batchQrId, extraInfoList);
          })
          .catch((err) => {
            console.error(err);
            loading.close();
          });
    },
    scanQrTextNext(value, userId, logisticsId, num, batchQrId, extraInfoList) {
      return new Promise((resolve, reject) => {
        warehouseApi
            .scanQrText(value, userId, logisticsId, num, this.matchChannel)
            .then((res) => {
              // console.log(res)
              let printDataList = [];
              let queuePrintDataList = []
              for (let data of res) {
                if (data.status == 0) {
                  console.log("data", data)
                  printDataList.push(data)
                  let item = this.getItemFromPrintData(data, value)
                  if (item.extraInfo) {
                    extraInfoList.push(item.extraInfo)
                  }
                  this.updatePrintDataList(item, batchQrId);
                  queuePrintDataList.push(item)
                } else {
                  let item = {
                    orderId: "",
                    qrText: value,
                    waybillId: "",
                    message: data.errorMsg,
                    status: data.status,
                    productPic: data.productPic,
                    productName: data.productName,
                    specs: data.spesc,
                    nextStatus: data.nextStatus,
                    errorMsg: data.errorMsg
                  };
                  this.updatePrintDataList(item, batchQrId);
                  queuePrintDataList.push(item)
                  // voice.aplayAudio()
                }
              }
              let printerName = this.printerName;
              if (printDataList.length > 0) {
                this.updatePrintResultForPrintDataList(queuePrintDataList)
                cloudprint.doPrintBath(printDataList, printerName).then(() => {
                  this.qrText = "";
                  resolve();
                }).catch((err) => {
                  console.error(err);
                  this.$message.error(err.message);
                  resolve();
                });
              } else {
                resolve();
              }
            })
            .catch((error) => {
              console.error(error);
              this.$message.error(error.message)
              let errMsg = error.message
              //网络超时
              if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') > -1) {
                errMsg = '网络超时:' + error.message
              } else {
                errMsg = '请求失败：' + error.message
              }
              errMsg += ';少打面单：' + num
              let errItem = {
                orderId: "",
                qrText: value,
                errNum: num,
                message: errMsg
              }
              // console.log('+++--', errItem)
              this.updatePrintDataList(errItem, batchQrId)
              resolve();
            });
      });
    },
    updatePrintDataList(printData, batchQrId) {
      const {qrText, status} = printData
      let queue = this.qrTextQueue
      let qrInfo = queue.find(item => item.qrText === qrText)
      // console.log("待push的printData", printData)
      // console.log("qrInfo", qrInfo, "传入的batchId", batchQrId)
      if (qrInfo && qrInfo.batchId === batchQrId) {
        //队列里面存在这个条码了，而且是同一批次
        //找到这个条码的信息
        if (status !== 0) {
          this.$set(qrInfo, 'error', true)
        }
        let printDataList = qrInfo.printDataList
        printDataList.unshift(printData)
      } else {
        //队列里面还不存在这个条码,分配一个batchId和当前的时间
        //构造一个qrInfo对象，加进去
        let qrInfo = {
          batchId: batchQrId,
          qrText,
          printDataList: [printData],
          time: timeUtil.format(new Date(), 'hh:mm:ss')
        }
        if (status !== 0) {
          this.$set(qrInfo, 'error', true)
        }
        queue.unshift(qrInfo)
      }
      //批次条码列表默认选中最近的扫码
      this.qrSelected = batchQrId

      if (queue.length > 30) {
        queue.pop()
      }
      this.qrTextQueue = queue

    },

    resetLastScanTimer() {
      if (this.lastScanTimer != null) {
        clearTimeout(this.lastScanTimer)
      }

      this.lastScanTimer = setTimeout(() => {
        // 长时间不操作自动清空配单来源选择
        this.matchChannel = ''
      }, 60 * 60 * 1000)
    },

    doBatchReprintPromise(index, selections, printerName) {
      return new Promise(resolve => {
        if (index >= selections.length) {
          resolve()
          return
        }

        const data = selections[index]
        this.doReprintPromise(data, printerName).then(() => {

        }).catch(err => {
          this.$message.error(err.message)
        }).finally(() => {
          this.doBatchReprintPromise(index + 1, selections, printerName)
        })
      })

    },

    reprint(data) {
      // console.log(data);
      let printerName = this.printerName
      if (data.waybillId) {
        this.$confirm(data.waybillId, "是否重新打印").then(() => {
          // 如果是打印状态失败的，重新拿printData重打，其他使用原来的printData重打
          this.doReprintPromise(data, printerName).then(() => {
            // this.$message.success('已打印')
          }).catch(err => {
            this.$message.error(err.message)
          })
        })
      } else {
        this.$message("没有可以打印的内容")
      }
    },

    doReprintPromise(data, printerName) {
      this.updatePrintResultForPrintDataList([data])
      return new Promise((resolve, reject) => {
        warehouseApi.reprintOrder(data.waybillId).then(printData => {
          this.waybillPopoverQueueUpdate(data.waybillId)
          this.displayWaybillsByPopoverManager()
          cloudprint.doPrint(printData, printerName, true).then(() => {
            resolve()
          }).catch(reject)
        }).catch(reject)
      })
    },

    changeVip(teamId, flushOrCallback) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      const vips = this.vips
      this.teamId = teamId;
      const index = vips.findIndex(v => v.teamId === teamId)
      if (index > -1) {
        const team = vips[index]
        if (team.version) {
          loading.close()
          this.newSys = true
        }
      }
      // 判断第二个参数的类型
      const isFlush = typeof flushOrCallback === 'boolean' ? flushOrCallback : false;
      const callback = typeof flushOrCallback === 'function' ? flushOrCallback : null;

      if (!isFlush) {
        this.taskGroup = {id: 0, title: "未分配"};
      }
      let taskGroup = this.taskGroup;
      let size = taskGroup.id ? this.multiPageSize : null
      warehouseApi
          .findMultipleOrder(teamId, taskGroup.id, null, null, size)
          .then((data) => {
            this.multipleOrders = data;
            warehouseApi
                .findAllRemnantReadyOrderGroup(teamId, 1)
                .then((data) => {
                  data.unshift({id: 0, title: "未分配"});
                  this.taskGroups = data;
                  loading.close()
                  // 执行回调函数
                  if (callback) {
                    callback();
                  }
                });
          })
          .catch((err) => {
            this.$message(err.message);
            loading.close()
            // 即使出错也执行回调
            if (callback) {
              callback();
            }
          });
    },
    todoProduct() {
      this.productDialogVisible = false;
      this.productItem = {};
    },

    getItemFromPrintData(data, value) {
      let isTikshop = false
      if (data.params) {
        isTikshop = true
      }
      let item
      const {waybillId} = data
      this.popoverManager.queue.push(waybillId)
      const isBoxSend = data.errorMsg && data.errorMsg.includes('盒子发货')
      if (isTikshop) {
        item = {
          orderId: data.orderId,
          qrText: value,
          waybillId: data.waybillId,
          message: "获取成功" + (isBoxSend ? '; 盒子发货' : ''),
          printData: data.printData,
          status: data.status,
          customArea: data.customArea,
          sender: data.sender,
          standardTemplateUrl: data.standardTemplateUrl,
          params: data.params,
          signature: data.signature,
          productPic: data.productPic,
          productName: data.productName,
          specs: data.spesc,
          code: data.code,
          dataFrom: data.dataFrom,
          nextStatus: data.nextStatus,
          errorMsg: data.errorMsg,
          extraInfo: data.extraInfo
        }
      } else {
        item = {
          orderId: data.orderId,
          qrText: value,
          waybillId: data.waybillId,
          message: "获取成功" + (isBoxSend ? '; 盒子发货' : ''),
          printData: data.printData,
          status: data.status,
          customArea: data.customArea,
          sender: data.sender,
          productPic: data.productPic,
          productName: data.productName,
          specs: data.spesc,
          code: data.code,
          dataFrom: data.dataFrom,
          nextStatus: data.nextStatus,
          errorMsg: data.errorMsg,
          extraInfo: data.extraInfo
        }
      }
      return item
    },
    /**
     * 处理全局键盘按下事件
     */
    handleGlobalScanKeyDown(e) {
      // 防止按键事件重复传递
      // e.preventDefault();
    },

    /**
     * 处理全局键盘抬起事件，用于捕获扫描枪输入
     */
    handleGlobalScanKeyUp(e) {
      if (this.view !== 6 && this.enableGlobalScanListener) {
        // 仅售后模块触发 且 打开开关才触发
        return
      }

      if (e.target.matches('input, textarea')) {
        // 如果是子元素的冒泡，阻止触发
        // console.log('阻止子元素冒泡触发', e.target)
        return;
      }

      if (!this.globalScanner) {
        this.globalScanner = this.getGlobalScannerHandler()
      }

      this.globalScanner.handleKeyUp(e)
    },

    updateScannerListeners() {
      if (this.enableGlobalScanListener) {
        window.addEventListener('keydown', this.handleGlobalScanKeyDown);
        window.addEventListener('keyup', this.handleGlobalScanKeyUp);
        console.log('物流单号扫描监听已启用');
      } else {
        window.removeEventListener('keydown', this.handleGlobalScanKeyDown);
        window.removeEventListener('keyup', this.handleGlobalScanKeyUp);
        console.log('物流单号扫描监听已禁用');
      }
    },
  },

  created() {
    // 监测打印机通信
    let _this = this;
    setInterval(() => {
      _this.printConnect = printer.getConnect() ? "success" : "danger";
      _this.davinciPrintConnect = davinci_printer.getConnect()
          ? "success"
          : "danger";
      _this.ksPrinterConnect = ks_printer.getConnect() ? "success" : "danger"
      _this.pddPrinterConnect = pddPrinter.getConnect() ? "success" : "danger"

      _this.channelPrinterConnect = channelPrinter.getConnect() ? "success" : "danger"
      _this.xhsPrinterConnect = xhsPrinter.getConnect() ? 'success' : 'danger'
    }, 1000 * 4);
  },
  destroyed() {
    window.onbeforeunload = null;
    // 销毁定时器
    if (this.lastScanTimer != null) {
      clearTimeout(this.lastScanTimer)
    }

    // 清理物流单号扫描处理器
    if (this.globalScanner) {
      // this.globalScanner.destroy();
      this.globalScanner = null;
    }

    // 确保移除全局键盘事件监听
    if (this.enableGlobalScanListener) {
      window.removeEventListener('keydown', this.handleGlobalScanKeyDown);
      window.removeEventListener('keyup', this.handleGlobalScanKeyUp);
    }
  }

};
</script>

<style>
#app {
  font-family: Helvetica, sans-serif;
  text-align: center;
}

.el-table .warning-row {
  color: red;
}

.el-table .success-row {
  color: black;
}

.el-table .success-row1 {
  background: #a6e782;
}

.el-table .select-row {
  background: lemonchiffon;
}

.el-table .warning-cell {
  background: lemonchiffon;
}

.el-table .success-cell {
  background: #a6e782;
}

.split {
  margin-top: 15px;
}

.productItem_div span {
  font-size: 16px;
  font-weight: 550;
}

.productItem_div div {
  margin-bottom: 30px;
}

.el-popover {
  margin-top: 8%;
  margin-left: auto;
  margin-right: auto;
  background: yellow;
  word-wrap: break-word;
}

#outerWaybillPopover {
  margin-top: -10%;
  margin-left: auto;
  margin-right: auto;
  background: yellow;
  word-wrap: break-word;
}

.outer-waybill-popover {
  padding: 30px 40px !important;
  position: fixed !important;
  top: 20px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  line-height: 1 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  background: yellow !important;
  margin-top: 0 !important;
  box-sizing: border-box !important;
}

.outer-waybill-popover > div {
  max-width: 100% !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
}

.waybill-popover {
  padding: 30px 40px !important;
  position: fixed !important;
  top: 10% !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  line-height: 1 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  background: yellow !important;
  margin-top: 0 !important;
  box-sizing: border-box !important;
}

.waybill-popover > div {
  max-width: 100% !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
}

.waybill-popover2 {
  /* margin-top: 0; */
  /* margin-left: 10%; */
  padding: 30px 40px !important;
  position: fixed !important;
  top: 20px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  line-height: 1 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  background: yellow !important;
  box-sizing: border-box !important;
}

.waybill-popover2 > div {
  max-width: 100% !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
}

.img_box_mini {
  width: 50px;
  height: 55px;
}

.delivery_advice div {
  margin-right: 25px;
}

.warning_text {
  color: red;
  font-weight: bold;
}

.sku-code {
  color: rgb(255, 153, 18);
}

.deliver-taq {
  font-size: 10px;
  margin-left: 8px;
}

label {
  font-weight: 700;
}

.img_box_tiny {
  width: 50px;
  height: 55px;
}

.dashed_line {
  height: 0;
  border-top: 1px dashed gray;
  margin-top: 5px;
  margin-bottom: 5px;
}

.box-view-enabled {
  font-size: 50px;
  font-weight: bold;
  color: #67C23A;
  cursor: pointer;
}

.box-view-disabled {
  font-size: 50px;
  position: relative;
  color: #C0C4CC;
  cursor: pointer;
}

.box-view-disabled::after {
  content: "";
  position: absolute;
  left: -16px;
  right: 0;
  top: 45%;
  width: 80px;
  border-top: 2px solid #C0C4CC; /* 调整边框的宽度和颜色 */
  transform: rotate(45deg);
}


.match_channel_success {
  border: 3px solid #67C23A;
  border-radius: 5px;
}

.match_channel_danger {
  border: 4px dashed red;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue